<template>
  <div v-if="globals.isAccessAllowed('LoopOp_SecurityUsers_ReadAll')">
    <!-- This component displays the user management  -->

    <ImportUsersModal
      :showDialog="showImportUsersDialog"
      :roleData="roleData"
      :clientList="clientList"
      :agencyList="agencyList"
      @dialogClosed="showImportUsersDialog = false"
      @importComplete="getUserData()"
    ></ImportUsersModal>

    <!-- Export Users -->
    <confirmation-dialog
      :dialogId="'UserManagementExportUsersConfirmation'"
      :confirmationTitle="lang.S0180"
      :yesButtonText="lang.S0181"
      :noButtonText="lang.S0182"
      :showDialog="showExportDialog"
      v-if="!feature.isAudiTarget"
      @onYesConfirmation="exportUsers"
      @dialogClosed="showExportDialog = false"
    >
      <template>
        <div class="form-group">
          <label
            for="exportUsersUserTypeSelect"
            class="col-md-2 control-label"
            >{{ lang.S0183 }}</label
          >
          <div class="col-md-10">
            <select2
              id="exportUsersUserTypeSelect"
              class="form-control"
              :afterChange="
                (u) => {
                  exportUsersDialogDataUserID = u;
                }
              "
              :placeholder="lang.S0184"
              :dataTransformer="(data) => Number(data[0].id)"
              :allowClear="true"
              v-model="exportUsersDialogData.UserTypeId"
            >
              <option
                v-for="type in roleData.filter(
                  (r) => r.RoleTypeName !== 'MSM_Administrator'
                )"
                :key="type.RoleTypeGuid"
                :value="type.UserTypeId"
              >
                {{ type.RoleTypeDisplayName }}
              </option>
            </select2>
          </div>
        </div>
        <template class="form-group" v-if="exportUsersDialogDataUserID == 4">
          <label for="exportUsersClientSelect" class="col-md-2 control-label">{{
            lang.S0185
          }}</label>
          <div class="col-md-10">
            <select2
              id="exportUsersClientSelect"
              class="form-control"
              :key="exportUsersDialogData.UserTypeId"
              :placeholder="lang.S0186"
              :allowClear="true"
              v-model="exportUsersDialogData.ClientId"
            >
              <option
                v-for="client in clientList"
                :key="client.ClientId"
                :value="client.ClientId"
              >
                {{ client.ClientName }}
              </option>
            </select2>
          </div>
        </template>
        <div class="form-group" v-show="exportUsersDialogData.UserTypeId == 2">
          <label for="exportUsersAgencySelect" class="col-md-2 control-label">{{
            lang.S0187
          }}</label>
          <div class="col-md-10">
            <select2
              id="exportUsersAgencySelect"
              class="form-control"
              :placeholder="lang.S0188"
              :allowClear="true"
              v-model="exportUsersDialogData.AgencyId"
            >
              <option
                v-for="agency in agencyList"
                :key="agency.AgencyGuid"
                :value="agency.AgencyId"
              >
                {{ agency.AgencyName }}
              </option>
            </select2>
          </div>
        </div>
      </template>
    </confirmation-dialog>

    <!-- ******************* -->
    <!-- *     Toolbar     * -->
    <!-- ******************* -->
    <!-- This is the panel on top of the page where buttons, pagination and searchbar are displayed -->
    <div class="panel panel-default" id="users-top-panel">
      <div class="panel-body">
        <div class="col-md-12">
          <!-- Add buttons here  -->
          <button
            id="user-management-refresh-button"
            class="btn btn-raised btn-top-bar"
            :disabled="!refreshEnabled"
            @click="getUserData()"
          >
            <i class="material-icons md-36">refresh</i>
            <br />
            {{ lang.S0000 }}
          </button>
          <button
            id="user-management-create-button"
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_SecurityUsers_Create')"
            @click="(selectedUser = ''), openEditUserDialog('create')"
          >
            <i class="material-icons md-36">add_box</i>
            <br />
            {{ lang.S0001 }}
          </button>
          <button
            id="user-management-edit-button"
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_SecurityUsers_Read')"
            @click="openEditUserDialog('edit')"
            :disabled="!selectedUser"
          >
            <i class="material-icons md-36">edit</i>
            <br />
            {{ lang.S0002 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_SecurityUsers_Create')"
            @click="openEditUserDialog('edit'), (copyUser = true)"
            :disabled="!selectedUser"
          >
            <i class="material-icons md-36">content_copy</i>
            <br />
            {{ lang.S0146 }}
          </button>
          <button
            id="user-management-delete-button"
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_SecurityUsers_Delete')"
            @click="openDeleteUserDialog()"
            :disabled="!selectedUser"
          >
            <i class="material-icons md-36">clear</i>
            <br />
            {{ lang.S0083 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_SecurityGroups_ReadAll')"
            :disabled="!selectedUser"
            @click="openSecurityDialog()"
          >
            <i class="material-icons md-36">lock</i>
            <br />
            {{ lang.S0003 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            v-if="!globals.isAgencyUser"
            :disabled="!selectedUserData.ClientGuid"
            @click="openSecurity2Dialog()"
          >
            <i class="material-icons md-36">lock</i>
            <br />
            {{ lang.S0138 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            v-if="
              globals.isAccessAllowed('LoopOp_Password_ChangePassword') &&
              globals.isAccessAllowed('LoopOp_Password_ValidatePassword')
            "
            :disabled="!selectedUser"
            @click="openChangePasswordDialog()"
          >
            <i class="material-icons md-36">vpn_key</i>
            <br />
            {{ lang.S0062 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_SecurityUsersExport_Create')"
            @click="showExportDialog = true"
          >
            <i class="material-icons md-36">file_download</i>
            <br />
            {{ lang.S0134 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_SecurityUsersImport_Create')"
            @click="showImportUsersDialog = true"
          >
            <i class="material-icons md-36">publish</i>
            <br />
            {{ lang.S0135 }}
          </button>
        </div>
      </div>

      <div class="panel-body">
        <div class="col-lg-7">
          <!-- Searchbar - triggered by enter key -->
          <div class="form-group searchbar">
            <input
              type="search"
              class="form-control"
              id="inputSearch"
              :placeholder="lang.S0004"
              v-model="filterStrings.Search"
              @keyup.enter="(selectedPage = 1), getUserData()"
            />
          </div>
        </div>

        <div class="col-lg-5 nopadding">
          <!-- Pagination -->
          <ul class="pagination-fonts pagination btn-group">
            <li>
              <!-- Dropdown: Select the number of elements per page -->
              <a
                role="button"
                class="dropdown-toggle"
                data-toggle="dropdown"
                id="elementsPerPageDropdown"
              >
                <i class="material-icons md-18">view_headline</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="elementsPerPageDropdown"
                :delay="globals.tooltipDelay"
                >{{ lang.S0005 }}</b-tooltip
              >
              <ul class="dropdown-menu">
                <!-- Add dropdown entries here -->
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 20 }"
                    role="button"
                    @click="updatePaging(1, 20)"
                    >20</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 50 }"
                    role="button"
                    @click="updatePaging(1, 50)"
                    >50</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 100 }"
                    role="button"
                    @click="updatePaging(1, 100)"
                    >100</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 200 }"
                    role="button"
                    @click="updatePaging(1, 200)"
                    >200</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 500 }"
                    role="button"
                    @click="updatePaging(1, 500)"
                    >500</a
                  >
                </li>
              </ul>
            </li>

            <!-- Jump to first page -->
            <li
              v-bind:class="{ disabled: !pageCount || selectedPage == 1 }"
              @click="updatePaging(1, 0)"
            >
              <a role="button" id="firstPageButton">
                <i class="material-icons md-18">first_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="firstPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.S0006 }}</b-tooltip
              >
            </li>
            <!-- ... -->
            <li v-if="pageCount > 7 && selectedPage > 4" class="disabled">
              <a role="button">...</a>
            </li>
            <!-- Pagenumbers -->
            <li
              v-for="pageNumber in getVisiblePages()"
              :key="pageNumber"
              v-bind:class="{ active: selectedPage == pageNumber }"
              @click="updatePaging(pageNumber, 0)"
            >
              <a role="button">{{ pageNumber }}</a>
            </li>
            <!-- ... -->
            <li
              v-if="pageCount > 7 && selectedPage < pageCount - 3"
              class="disabled"
            >
              <a role="button">...</a>
            </li>
            <!-- Jump to last page -->
            <li
              v-bind:class="{
                disabled: !pageCount || selectedPage == pageCount,
              }"
              @click="updatePaging(pageCount, 0)"
            >
              <a role="button" id="lastPageButton">
                <i class="material-icons md-18">last_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="lastPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.S0007 }}</b-tooltip
              >
            </li>
            <li class="disabled">
              <a role="button" id="usersTotalElementsCounter">{{
                totalElementsCount
              }}</a>
              <b-tooltip
                ref="tooltip"
                target="usersTotalElementsCounter"
                :delay="globals.tooltipDelay"
                >{{ lang.S0200 }}</b-tooltip
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- ******************* -->
    <!-- *      Table      * -->
    <!-- ******************* -->
    <!-- This is the main panel on the page where all data is displayed in a table -->
    <div class="panel panel-default">
      <div class="panel-body">
        <div class="table-space main-table-scrollbar">
          <table class="table table-striped table-hover main-table">
            <thead>
              <tr>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortUserData('RoleType')"
                  >
                    {{ lang.S0009 }}
                    <span
                      v-if="sortField == 'RoleType' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'RoleType' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortUserData('Role')"
                  >
                    {{ lang.S0133 }}
                    <span
                      v-if="sortField == 'Role' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'Role' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortUserData('Active')"
                  >
                    {{ lang.S0163 }}
                    <span
                      v-if="sortField == 'Active' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'Active' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortUserData('Company')"
                  >
                    {{ lang.S0160 }}
                    <span
                      v-if="sortField == 'Company' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'Company' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortUserData('LoginName')"
                  >
                    {{ lang.S0010 }}
                    <span
                      v-if="sortField == 'LoginName' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'LoginName' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortUserData('FirstName')"
                  >
                    {{ lang.S0011 }}
                    <span
                      v-if="sortField == 'FirstName' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'FirstName' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortUserData('LastName')"
                  >
                    {{ lang.S0012 }}
                    <span
                      v-if="sortField == 'LastName' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'LastName' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortUserData('Gender')"
                  >
                    {{ lang.S0013 }}
                    <span
                      v-if="sortField == 'Gender' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'Gender' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortUserData('City')"
                  >
                    {{ lang.S0014 }}
                    <span
                      v-if="sortField == 'City' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'City' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <!-- <th class="text-center sticky-header">
                <a class="table-header" role="button" @click="sortUserData('Region')">
                  {{lang.S0015}}
                  <span
                    v-if="sortField == 'Region' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'Region' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>-->
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortUserData('Country')"
                  >
                    {{ lang.S0016 }}
                    <span
                      v-if="sortField == 'Country' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'Country' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortUserData('Email')"
                  >
                    {{ lang.S0017 }}
                    <span
                      v-if="sortField == 'Email' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'Email' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
              </tr>
              <tr class="table-filters">
                <!-- The first row contains inputs to allow filtering per column -> triggered by enter key -->
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.S0018"
                      v-model="filterStrings.RoleType"
                      @keyup.enter="(selectedPage = 1), getUserData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.S0018"
                      v-model="filterStrings.Role"
                      @keyup.enter="(selectedPage = 1), getUserData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <a
                      role="button"
                      @click="
                        (filterStrings.Active = (filterStrings.Active + 1) % 3),
                          getUserData()
                      "
                    >
                      <div
                        class="cb-active-filter-container"
                        v-if="filterStrings.Active == 1"
                      >
                        <i class="material-icons md-24">check_box</i>
                      </div>
                      <div
                        class="cb-active-filter-container"
                        v-else-if="filterStrings.Active == 0"
                      >
                        <i class="material-icons md-24"
                          >check_box_outline_blank</i
                        >
                      </div>
                      <div class="cb-active-filter-container" v-else>
                        <i class="material-icons md-24"
                          >indeterminate_check_box</i
                        >
                      </div>
                    </a>
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.S0018"
                      v-model="filterStrings.Company"
                      @keyup.enter="(selectedPage = 1), getUserData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.S0018"
                      v-model="filterStrings.LoginName"
                      @keyup.enter="(selectedPage = 1), getUserData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.S0018"
                      v-model="filterStrings.FirstName"
                      @keyup.enter="(selectedPage = 1), getUserData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.S0018"
                      v-model="filterStrings.LastName"
                      @keyup.enter="(selectedPage = 1), getUserData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.S0018"
                      v-model="filterStrings.Gender"
                      @keyup.enter="(selectedPage = 1), getUserData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.S0018"
                      v-model="filterStrings.City"
                      @keyup.enter="(selectedPage = 1), getUserData()"
                    />
                  </div>
                </th>
                <!-- <th class="nopadding sticky-filter" style="width:9%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.S0018"
                    v-model="filterStrings.Region"
                    @keyup.enter="selectedPage = 1, getUserData()"
                  >
                </div>
              </th>-->
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.S0018"
                      v-model="filterStrings.Country"
                      @keyup.enter="(selectedPage = 1), getUserData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.S0018"
                      v-model="filterStrings.Email"
                      @keyup.enter="(selectedPage = 1), getUserData()"
                    />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <!-- Doubleclick on the table row opens the edit dialog, singleclick selects the user -->
              <tr
                role="button"
                v-for="user in userData"
                :key="user.UserId"
                @click="(selectedUser = user.UserId), (selectedUserData = user)"
                @dblclick="
                  !globals.isAccessAllowed('LoopOp_SecurityUsers_Read') ||
                    openEditUserDialog('edit')
                "
                :class="{ info: user.UserId == selectedUser }"
              >
                <!-- Add table data here -->
                <td>{{ user.RoleType }}</td>
                <td>{{ user.Role }}</td>
                <td style="padding: 6px 0 0 0">
                  <i class="material-icons md-24 user-active" v-if="user.Active"
                    >done</i
                  >
                  <i class="material-icons md-24 user-inactive" v-else>clear</i>
                </td>
                <td>{{ user.Company }}</td>
                <td>{{ user.LoginName }}</td>
                <td>{{ user.FirstName }}</td>
                <td>{{ user.LastName }}</td>
                <td>{{ user.Gender }}</td>
                <td>{{ user.City }}</td>
                <!-- <td>{{ user.Region }}</td> -->
                <td>{{ user.Country }}</td>
                <td>{{ user.Email }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- ******************* -->
    <!-- *      Modal      * -->
    <!-- ******************* -->
    <!-- This modal is for editing or creating new users -->
    <div
      class="modal fade"
      id="editUser"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <!-- Modal Title -->
            <h4 class="modal-title">
              <b>{{ editUserDialogData.dialogTitle }}</b>
            </h4>

            <!-- User ID, and History -->
            <div v-if="editUserDialogData.userData.UserId != undefined">
              <label class="control-label"
                >ID: {{ editUserDialogData.userData.UserId }}</label
              >
              <i
                id="showUserHistoryInfoIcon"
                class="material-icons md-24"
                @click="showUserHistory()"
                >history</i
              >
              <b-tooltip
                ref="tooltip"
                target="showUserHistoryInfoIcon"
                :delay="globals.tooltipDelay"
                >{{ lang.S0201 }}</b-tooltip
              >
            </div>
          </div>
          <div class="modal-body">
            <!-- Accordion - hides content that is not used -->
            <div
              class="panel-group"
              id="accordion"
              role="tablist"
              aria-multiselectable="true"
            >
              <div class="panel panel-default">
                <!-- Accordion entry 1 -->
                <div
                  class="panel-heading"
                  role="button"
                  id="headingGeneral"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseGeneral"
                  aria-expanded="true"
                  aria-controls="collapseGeneral"
                >
                  <h4 class="panel-title">
                    <a class="collapsed">{{ lang.S0019 }}</a>
                  </h4>
                </div>
                <div
                  id="collapseGeneral"
                  class="panel-collapse collapse in"
                  role="tabpanel"
                  aria-labelledby="headingGeneral"
                >
                  <div class="panel-body">
                    <!-- Add inputs here -->
                    <div class="form-group">
                      <label for="inputLoginName" class="col-md-2 control-label"
                        >{{ lang.S0020 }}*</label
                      >
                      <div class="col-md-10">
                        <input
                          type="text"
                          class="form-control"
                          id="inputLoginName"
                          name="inputLoginName"
                          v-model="editUserDialogData.userData.LoginName"
                          @keyup="validateInput('inputLoginName')"
                          required
                        />
                        <span
                          v-show="inputHasError('inputLoginName')"
                          class="help-block error text-danger"
                          >{{ lang.S0095 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="inputFirstName" class="col-md-2 control-label"
                        >{{ lang.S0022 }}*</label
                      >
                      <div class="col-md-10">
                        <input
                          type="text"
                          class="form-control"
                          id="inputFirstName"
                          name="inputFirstName"
                          v-model="editUserDialogData.userData.FirstName"
                          @keyup="validateInput('inputFirstName')"
                          required
                        />
                        <span
                          v-show="inputHasError('inputFirstName')"
                          class="help-block error text-danger"
                          >{{ lang.S0095 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="inputLastName" class="col-md-2 control-label"
                        >{{ lang.S0023 }}*</label
                      >
                      <div class="col-md-10">
                        <input
                          type="text"
                          class="form-control"
                          id="inputLastName"
                          name="inputLastName"
                          v-model="editUserDialogData.userData.LastName"
                          @keyup="validateInput('inputLastName')"
                          required
                        />
                        <span
                          v-show="inputHasError('inputLastName')"
                          class="help-block error text-danger"
                          >{{ lang.S0095 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputCompanyName"
                        class="col-md-2 control-label"
                        >{{ lang.S0024 }}</label
                      >
                      <div class="col-md-10">
                        <input
                          type="text"
                          class="form-control"
                          id="inputCompanyName"
                          v-model="editUserDialogData.userData.CompanyName"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="inputGender" class="col-md-2 control-label"
                        >{{ lang.S0025 }}*</label
                      >
                      <div class="col-md-10">
                        <select2
                          class="form-control"
                          id="inputUserGender"
                          v-model="editUserDialogData.userData.Gender"
                          :key="editUserDialogData.userData.Gender"
                          @change="validationInput('inputUserGender')"
                          :placeholder="lang.S0041"
                          required
                        >
                          <option value disabled hidden>
                            {{ lang.S0041 }}
                          </option>
                          <option value="M">{{ lang.S0026 }}</option>
                          <option value="F">{{ lang.S0027 }}</option>
                          <option value="D">{{ lang.S0203 }}</option>
                        </select2>
                        <span
                          v-show="inputHasError('inputUserGender')"
                          class="help-block error text-danger"
                          >{{ lang.S0095 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputRoleType"
                        class="col-md-2 control-label"
                        >{{ lang.S0009 }}</label
                      >
                      <div
                        class="col-md-10"
                        v-if="editUserDialogData.userData.RoleTypeGuid"
                      >
                        <select2
                          id="editUserDialogData.userData.RoleTypeGuid"
                          class="form-control"
                          v-model="editUserDialogData.userData.RoleTypeGuid"
                          :key="editUserDialogData.userData.RoleTypeGuid"
                          :afterChange="roleTypeChanged"
                        >
                          <option
                            v-for="roleType in roleData"
                            :key="roleType.RoleTypeGuid"
                            :value="roleType.RoleTypeGuid"
                          >
                            {{ roleType.RoleTypeDisplayName }}
                          </option>
                        </select2>
                      </div>
                    </div>
                    <div
                      class="form-group"
                      v-if="
                        globals.roleTypeHasSuffix(
                          editUserDialogData.userData.RoleTypeGuid,
                          'Agency'
                        )
                      "
                    >
                      <label for="selectAgency" class="col-md-2 control-label"
                        >{{ lang.S0116 }}*</label
                      >
                      <div class="col-md-10">
                        <select2
                          id="selectAgency"
                          name="selectAgency"
                          class="form-control"
                          :afterChange="
                            (a) => {
                              validateInput('selectAgency');
                            }
                          "
                          :placeholder="lang.S0041"
                          v-model="editUserDialogData.userData.AgencyGuid"
                          required
                        >
                          <option
                            v-for="agency in agencyList"
                            :key="agency.AgencyGuid"
                            :value="agency.AgencyGuid"
                          >
                            {{ agency.AgencyName }}
                          </option>
                        </select2>
                      </div>
                    </div>
                    <div
                      class="form-group"
                      v-if="
                        globals.roleTypeHasSuffix(
                          editUserDialogData.userData.RoleTypeGuid,
                          'Client'
                        )
                      "
                    >
                      <label for="selectClient" class="col-md-2 control-label"
                        >{{ lang.S0111 }}*</label
                      >
                      <div class="col-md-10">
                        <select2
                          id="selectClient"
                          name="selectClient"
                          class="form-control"
                          v-if="editUserDialogData.userData.RoleTypeGuid"
                          :dataTransformer="(data) => Number(data[0].id)"
                          :afterChange="
                            (c) => {
                              validateInput('selectClient');
                            }
                          "
                          v-model="editUserDialogData.userData.ClientId"
                          :placeholder="lang.S0041"
                          required
                        >
                          <option
                            v-for="client in clientList"
                            :key="client.ClientId"
                            :value="client.ClientId"
                          >
                            {{ client.ClientName }}
                          </option>
                        </select2>
                      </div>
                    </div>
                    <div
                      class="form-group"
                      v-if="
                        !globals.roleTypeHasSuffix(
                          editUserDialogData.userData.RoleTypeGuid,
                          'Audi'
                        )
                      "
                    >
                      <label
                        for="editUserSelectRole"
                        class="col-md-2 control-label"
                        >{{ lang.S0133 }}*</label
                      >
                      <div class="col-md-10">
                        <select2
                          id="editUserSelectRole"
                          name="editUserSelectRole"
                          ref="editUserSelectRole"
                          class="form-control"
                          :afterChange="
                            (a) => {
                              validateInput('editUserSelectRole');
                            }
                          "
                          :placeholder="lang.S0041"
                          v-model="editUserDialogData.userData.RoleGuid"
                          :key="editUserDialogData.userData.RoleGuid"
                          required
                        >
                          <option
                            v-for="role in editUserDialogData.currentRoles"
                            :key="role.RoleGuid"
                            :value="role.RoleGuid"
                          >
                            {{ role.RoleDisplayName }}
                          </option>
                        </select2>
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputLocalization"
                        class="col-md-2 control-label"
                        >{{ lang.S0028 }}</label
                      >
                      <div class="col-md-10">
                        <select2
                          id="inputLocalization"
                          class="form-control"
                          v-model="editUserDialogData.userData.LanguageCode"
                          :key="editUserDialogData.userData.LanguageCode"
                          :placeholder="lang.S0041"
                        >
                          <option
                            v-for="(language, id) in languageList"
                            :key="id + '_' + language"
                            :value="id"
                          >
                            {{ language }}
                          </option>
                        </select2>
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputDefaultWelcomePage"
                        class="col-md-2 control-label"
                        >{{ lang.S0030 }}</label
                      >
                      <div class="col-md-10">
                        <input
                          type="text"
                          class="form-control"
                          id="inputDefaultWelcomePage"
                          v-model="
                            editUserDialogData.userData.DefaultWelcomePage
                          "
                        />
                        <b-tooltip
                          ref="tooltip"
                          target="inputDefaultWelcomePage"
                          :delay="globals.tooltipDelay"
                          placement="right"
                        >
                          <b>{{ lang.S0031 }}:</b>
                          <br />clientname.msmloop.com
                        </b-tooltip>
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputDisabled"
                        class="col-md-2 control-label"
                        >{{ lang.S0033 }}</label
                      >
                      <div class="col-md-10">
                        <select
                          class="form-control"
                          v-model="editUserDialogData.userData.Active"
                          @change="$forceUpdate()"
                        >
                          <option value="true">{{ lang.S0034 }}</option>
                          <option value="false">{{ lang.S0035 }}</option>
                        </select>
                      </div>
                    </div>

                    <div
                      class="form-group"
                      v-if="
                        selectedUserData.RoleGuid === 'Market' &&
                        selectedUserData.RoleTypeGuid === 'Client'
                      "
                    >
                      <label for="inputMarket" class="col-md-2 control-label">{{
                        lang.S0202
                      }}</label>
                      <div class="col-md-10">
                        <select
                          class="form-control"
                          @change="$forceUpdate()"
                          v-model="editUserDialogData.userData.Market_short"
                        >
                          <option disabled :value="'undefined'" hidden>
                            {{ lang.S0041 }}
                          </option>
                          <option
                            v-for="(market, index) in marketList"
                            :key="index"
                            :value="market.marketShortName"
                          >
                            {{ market.marketShortName }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Accordion entry 2 -->
                <div
                  class="panel-heading"
                  role="button"
                  id="headingContact"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseContact"
                  aria-expanded="false"
                  aria-controls="collapseContact"
                >
                  <h4 class="panel-title">
                    <a class="collapsed">{{ lang.S0036 }}</a>
                  </h4>
                </div>
                <div
                  id="collapseContact"
                  class="panel-collapse collapse"
                  role="tabpanel"
                  aria-labelledby="headingContact"
                >
                  <div class="panel-body">
                    <div class="form-group">
                      <label
                        for="inputAddress1"
                        class="col-md-2 control-label"
                        >{{ lang.S0037 }}</label
                      >
                      <div class="col-md-10">
                        <input
                          type="text"
                          class="form-control"
                          id="inputAddress1"
                          v-model="editUserDialogData.userData.Address1"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputAddress2"
                        class="col-md-2 control-label"
                        >{{ lang.S0038 }}</label
                      >
                      <div class="col-md-10">
                        <input
                          type="text"
                          class="form-control"
                          id="inputAddress2"
                          v-model="editUserDialogData.userData.Address2"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="inputCity" class="col-md-2 control-label">{{
                        lang.S0039
                      }}</label>
                      <div class="col-md-10">
                        <input
                          type="text"
                          class="form-control"
                          id="inputCity"
                          v-model="editUserDialogData.userData.City"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputCountry"
                        class="col-md-2 control-label"
                        >{{ lang.S0042 }}</label
                      >
                      <div class="col-md-10">
                        <select
                          class="form-control"
                          @change="
                            changedCountry(editUserDialogData.userData.Country)
                          "
                          v-model="editUserDialogData.userData.Country"
                        >
                          <option disabled :value="'undefined'" hidden>
                            {{ lang.S0041 }}
                          </option>
                          <option
                            v-for="(country, ISOCode) in globals.countryList"
                            :key="ISOCode"
                            :value="ISOCode"
                          >
                            {{ country }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="inputRegion" class="col-md-2 control-label">{{
                        lang.S0040
                      }}</label>
                      <div class="col-md-10">
                        <select
                          class="form-control"
                          v-model="editUserDialogData.userData.RegionGuid"
                          :disabled="
                            editUserDialogData.currentRegions.length < 1
                          "
                        >
                          <option
                            disabled
                            :value="'undefined'"
                            hidden
                            v-if="editUserDialogData.currentRegions.length > 0"
                          >
                            {{ lang.S0041 }}
                          </option>
                          <option
                            v-for="region in editUserDialogData.currentRegions"
                            :key="region.RegionGuid"
                            :value="region.RegionGuid"
                          >
                            {{ region.RegionName }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputTimeZone"
                        class="col-md-2 control-label"
                        >{{ lang.S0029 }}</label
                      >
                      <div class="col-md-10">
                        <select
                          class="form-control"
                          v-model="editUserDialogData.userData.TimeZone"
                          :disabled="
                            editUserDialogData.currentTimeZones.length < 1
                          "
                        >
                          <option
                            disabled
                            :value="'undefined'"
                            hidden
                            v-if="
                              editUserDialogData.currentTimeZones.length > 0
                            "
                          >
                            {{ lang.S0041 }}
                          </option>
                          <option
                            v-for="tz in editUserDialogData.currentTimeZones"
                            :key="tz.TimeZoneId"
                            :value="tz.TimeZoneId"
                          >
                            {{ tz.TimeZoneName }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputPostalCode"
                        class="col-md-2 control-label"
                        >{{ lang.S0043 }}</label
                      >
                      <div class="col-md-10">
                        <input
                          type="text"
                          class="form-control"
                          id="inputPostalCode"
                          v-model="editUserDialogData.userData.PostalCode"
                        />
                      </div>
                    </div>
                    <div class="form-group form-group-small">
                      <label
                        for="inputGeographyFromGeocoding_Lat"
                        class="col-md-2 control-label"
                        >{{ lang.S0117 }}</label
                      >
                      <div class="col-md-4">
                        <input
                          type="number"
                          step="0.000001"
                          min="-90"
                          max="90"
                          class="form-control"
                          id="inputGeographyFromGeocoding_Lat"
                          v-model="
                            editUserDialogData.userData
                              .GeographyFromGeocoding_Lat
                          "
                          @input="
                            validateInput('inputGeographyFromGeocoding_Lat')
                          "
                        />
                        <span
                          v-show="
                            inputHasError('inputGeographyFromGeocoding_Lat')
                          "
                          class="help-block error text-danger"
                          >{{ lang.S0122 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group form-group-small">
                      <label
                        for="GeographyFromGeocoding_Long"
                        class="col-md-2 control-label"
                        >{{ lang.S0118 }}</label
                      >
                      <div class="col-md-4">
                        <input
                          type="number"
                          step="0.000001"
                          min="-180"
                          max="180"
                          class="form-control"
                          id="GeographyFromGeocoding_Long"
                          v-model="
                            editUserDialogData.userData
                              .GeographyFromGeocoding_Long
                          "
                          @input="validateInput('GeographyFromGeocoding_Long')"
                        />
                        <span
                          v-show="inputHasError('GeographyFromGeocoding_Long')"
                          class="help-block error text-danger"
                          >{{ lang.S0122 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group form-group-small">
                      <label
                        for="GeographyFromPostalCode_Lat"
                        class="col-md-2 control-label"
                        >{{ lang.S0119 }}</label
                      >
                      <div class="col-md-4">
                        <input
                          type="number"
                          step="0.000001"
                          min="-90"
                          max="90"
                          class="form-control"
                          id="GeographyFromPostalCode_Lat"
                          v-model="
                            editUserDialogData.userData
                              .GeographyFromPostalCode_Lat
                          "
                          @input="validateInput('GeographyFromPostalCode_Lat')"
                        />
                        <span
                          v-show="inputHasError('GeographyFromPostalCode_Lat')"
                          class="help-block error text-danger"
                          >{{ lang.S0122 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group form-group-small">
                      <label
                        for="GeographyFromPostalCode_Long"
                        class="col-md-2 control-label"
                        >{{ lang.S0120 }}</label
                      >
                      <div class="col-md-4">
                        <input
                          type="number"
                          step="0.000001"
                          min="-180"
                          max="180"
                          class="form-control"
                          id="GeographyFromPostalCode_Long"
                          v-model="
                            editUserDialogData.userData
                              .GeographyFromPostalCode_Long
                          "
                          @input="validateInput('GeographyFromPostalCode_Long')"
                        />
                        <span
                          v-show="inputHasError('GeographyFromPostalCode_Long')"
                          class="help-block error text-danger"
                          >{{ lang.S0122 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group" style="clear: both">
                      <label
                        for="inputDistanceUnit"
                        class="col-md-2 control-label"
                        >{{ lang.S0121 }}</label
                      >
                      <div class="col-md-10">
                        <select
                          class="form-control"
                          v-model="editUserDialogData.userData.DistanceUnit"
                        >
                          <option disabled :value="'undefined'" hidden>
                            {{ lang.S0041 }}
                          </option>
                          <option
                            v-for="(unit, key) in distanceUnits"
                            :key="key"
                            :value="key"
                          >
                            {{ unit }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputPhoneHome"
                        class="col-md-2 control-label"
                        >{{ lang.S0044 }}</label
                      >
                      <div class="col-md-10">
                        <input
                          type="tel"
                          class="form-control"
                          id="inputPhoneHome"
                          v-model="editUserDialogData.userData.PhoneHome"
                          @keyup="validateInput('inputPhoneHome')"
                        />
                        <span
                          v-show="inputHasError('inputPhoneHome')"
                          class="help-block error text-danger"
                          >{{ lang.S0096 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputPhoneWork"
                        class="col-md-2 control-label"
                        >{{ lang.S0045 }}</label
                      >
                      <div class="col-md-10">
                        <input
                          type="tel"
                          class="form-control"
                          id="inputPhoneWork"
                          v-model="editUserDialogData.userData.PhoneWork"
                          @keyup="validateInput('inputPhoneWork')"
                        />
                        <span
                          v-show="inputHasError('inputPhoneWork')"
                          class="help-block error text-danger"
                          >{{ lang.S0096 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputPhoneMobile"
                        class="col-md-2 control-label"
                        >{{ lang.S0046 }}</label
                      >
                      <div class="col-md-10">
                        <input
                          type="tel"
                          class="form-control"
                          id="inputPhoneMobile"
                          v-model="editUserDialogData.userData.PhoneMobile"
                          @keyup="validateInput('inputPhoneMobile')"
                        />
                        <span
                          v-show="inputHasError('inputPhoneMobile')"
                          class="help-block error text-danger"
                          >{{ lang.S0096 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="inputFax" class="col-md-2 control-label">{{
                        lang.S0047
                      }}</label>
                      <div class="col-md-10">
                        <input
                          type="tel"
                          class="form-control"
                          id="inputFax"
                          v-model="editUserDialogData.userData.Fax"
                          @keyup="validateInput('inputFax')"
                        />
                        <span
                          v-show="inputHasError('inputFax')"
                          class="help-block error text-danger"
                          >{{ lang.S0097 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="inputEmail" class="col-md-2 control-label">{{
                        lang.S0048
                      }}</label>
                      <div class="col-md-10">
                        <input
                          type="email"
                          class="form-control"
                          id="inputEmail"
                          name="inputEmail"
                          v-model="editUserDialogData.userData.Email"
                          @keyup="validateInput('inputEmail')"
                        />
                        <span
                          v-show="inputHasError('inputEmail')"
                          class="help-block error text-danger"
                          >{{ lang.S0098 }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <b-alert
              variant="danger"
              dismissible
              :show="editUserDialogData.showAlert"
              @dismissed="editUserDialogData.showAlert = false"
              >{{ lang.S0049 }}</b-alert
            >
          </div>
          <div class="modal-footer">
            <!-- Add modal buttons here -->
            <button
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
              @click="copyUser = false"
            >
              {{ lang.S0050 }}
            </button>
            <button
              id="user-management-modal-save-button"
              type="button"
              class="btn btn-raised dialog-btn-primary"
              @click="validateBeforeSubmit('editUser')"
              :disabled="
                !globals.isAccessAllowed('LoopOp_SecurityUsers_Update')
              "
            >
              {{ lang.S0051 }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- This modal is for security information of users -->
    <div
      class="modal fade"
      id="securityDialog"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-lg" style="width: 80vw">
        <div class="modal-content">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <!-- Modal title -->
            <h4 class="modal-title">
              <b>{{ lang.S0054 }}</b>
            </h4>
            <p>{{ getSelectedUserInfoText() }}</p>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group">
                <!-- Tabs for selecting the import type -->
                <ul
                  class="nav nav-tabs nav-security"
                  style="margin-bottom: 15px"
                >
                  <!-- <li class="active">
                    <a
                      href="#roleDataTab"
                      data-toggle="tab"
                      v-if="globals.isAccessAllowed('LoopOp_SecurityGroups_ReadAll') && globals.isAccessAllowed('LoopOp_SecurityUsersSecurityGroups_Read')"
                    >{{lang.S0055}}</a>
                  </li>-->
                  <li class="active">
                    <a
                      href="#customGroupDataTab"
                      data-toggle="tab"
                      v-if="
                        globals.isAccessAllowed(
                          'LoopOp_SecurityGroups_ReadAll'
                        ) &&
                        globals.isAccessAllowed(
                          'LoopOp_SecurityUsersSecurityGroups_Read'
                        )
                      "
                      >{{ lang.S0056 }}</a
                    >
                  </li>
                  <li>
                    <a
                      href="#groupManagementTab"
                      data-toggle="tab"
                      v-if="
                        globals.isAccessAllowed('LoopOp_SecurityGroups_ReadAll')
                      "
                      >{{ lang.S0064 }}</a
                    >
                  </li>
                </ul>
                <div class="tab-content">
                  <div
                    class="tab-pane fade in"
                    v-for="(groupList, key) in securityDialogData.dataLists"
                    :key="key"
                    :id="key + 'Tab'"
                    :class="{ active: key == 'customGroupData' }"
                  >
                    <!-- Tab for security roles -->
                    <div class="col-md-12">
                      <!-- Buttons for switching group assignments -->
                      <button
                        class="btn btn-fab btn-fab-mini dialog-btn-primary"
                        :disabled="
                          securityDialogData.selectedAssignedGroupGuids
                            .length == 0 ||
                          !globals.isAccessAllowed(
                            'LoopOp_SecurityUsersSecurityGroups_Update'
                          )
                        "
                        @click.prevent="unassignGroups()"
                      >
                        <i class="material-icons">arrow_back</i>
                      </button>
                      <button
                        class="btn btn-fab btn-fab-mini dialog-btn-primary"
                        :disabled="
                          securityDialogData.selectedUnassignedGroupGuids
                            .length == 0 ||
                          !globals.isAccessAllowed(
                            'LoopOp_SecurityUsersSecurityGroups_Update'
                          )
                        "
                        @click.prevent="assignGroups()"
                      >
                        <i class="material-icons">arrow_forward</i>
                      </button>
                    </div>

                    <div class="col-md-6">
                      <!-- List with available groups -->
                      <table class="table table-striped table-hover">
                        <thead>
                          <tr>
                            <th class="text-center sticky-header">
                              {{ lang.S0058 }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            role="button"
                            v-for="group in groupListAvailable"
                            :key="group.GroupGuid"
                            @click="
                              toggleListItem(
                                securityDialogData.selectedUnassignedGroupGuids,
                                group.GroupGuid
                              )
                            "
                            @dblclick="
                              !globals.isAccessAllowed(
                                'LoopOp_SecurityUsersSecurityGroups_Update'
                              ) ||
                                ((securityDialogData.selectedUnassignedGroupGuids =
                                  []),
                                toggleListItem(
                                  securityDialogData.assignedGroupGuids,
                                  group.GroupGuid
                                ))
                            "
                            :class="{
                              info:
                                securityDialogData.selectedUnassignedGroupGuids.indexOf(
                                  group.GroupGuid
                                ) > -1,
                            }"
                          >
                            <td :id="'tdAvailable' + key + group.GroupName">
                              {{ group.GroupName }}
                              <span
                                v-show="group.IsReportingGroup"
                                class="reporting-group-table-symbol"
                                >R</span
                              >
                            </td>
                            <b-tooltip
                              ref="tooltip"
                              :target="'tdAvailable' + key + group.GroupName"
                              :delay="globals.tooltipDelay"
                              >{{ group.GroupDescription }}</b-tooltip
                            >
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="col-md-6">
                      <!-- List with assigned groups -->
                      <table class="table table-striped table-hover">
                        <thead>
                          <tr>
                            <th class="text-center sticky-header">
                              {{ lang.S0059 }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            role="button"
                            v-for="group in groupListAssigned"
                            :key="group.GroupGuid"
                            @click="
                              toggleListItem(
                                securityDialogData.selectedAssignedGroupGuids,
                                group.GroupGuid
                              )
                            "
                            @dblclick="
                              !globals.isAccessAllowed(
                                'LoopOp_SecurityUsersSecurityGroups_Update'
                              ) ||
                                ((securityDialogData.selectedAssignedGroupGuids =
                                  []),
                                toggleListItem(
                                  securityDialogData.assignedGroupGuids,
                                  group.GroupGuid
                                ))
                            "
                            :class="{
                              info:
                                securityDialogData.selectedAssignedGroupGuids.indexOf(
                                  group.GroupGuid
                                ) > -1,
                            }"
                          >
                            <td :id="'tdAssigned' + key + group.GroupName">
                              {{ group.GroupName }}
                              <span
                                v-show="group.IsReportingGroup"
                                class="reporting-group-table-symbol"
                                >R</span
                              >
                            </td>
                            <b-tooltip
                              ref="tooltip"
                              :target="'tdAssigned' + key + group.GroupName"
                              :delay="globals.tooltipDelay"
                              >{{ group.GroupDescription }}</b-tooltip
                            >
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <!-- Gruppenverwaltung -->
                  <div class="tab-pane fade in" id="groupManagementTab">
                    <div class="col-md-6">
                      <!-- List with available groups to select from -->
                      <table class="table table-striped table-hover">
                        <thead>
                          <tr>
                            <th class="text-center sticky-header">
                              {{ lang.S0078 }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            role="button"
                            v-for="group in securityDialogData.dataLists
                              .customGroupData"
                            :key="group.GroupGuid"
                            @click="selectGroup(group.GroupGuid)"
                            :class="{
                              info:
                                securityDialogData.groupManagement
                                  .selectedGroup == group.GroupGuid,
                            }"
                          >
                            <td
                              :id="
                                'tdAvailableCustomGroupData' + group.GroupName
                              "
                            >
                              {{ group.GroupName }}
                              <span
                                v-show="group.IsReportingGroup"
                                class="reporting-group-table-symbol"
                                >R</span
                              >
                            </td>
                            <b-tooltip
                              ref="tooltip"
                              :target="
                                'tdAvailableCustomGroupData' + group.GroupName
                              "
                              :delay="globals.tooltipDelay"
                              >{{ group.GroupDescription }}</b-tooltip
                            >
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="col-md-6">
                      <!-- Input form for new group creation and deletion of a selected group -->
                      <table class="table table-striped table-hover">
                        <thead>
                          <tr>
                            <th class="text-center sticky-header">
                              {{ lang.S0079 }}
                            </th>
                          </tr>
                        </thead>
                      </table>
                      <div class="form-group">
                        <label
                          for="inputGroupName"
                          class="col-md-3 control-label"
                          >{{ lang.S0080 }} *</label
                        >
                        <div class="col-md-9">
                          <input
                            type="text"
                            class="form-control"
                            id="inputGroupName"
                            v-model="
                              securityDialogData.groupManagement
                                .selectedGroupData.GroupName
                            "
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputGroupDescription"
                          class="col-md-3 control-label"
                          >{{ lang.S0081 }}</label
                        >
                        <div class="col-md-9">
                          <textarea
                            type="text"
                            rows="3"
                            class="form-control"
                            id="inputGroupDescription"
                            v-model="
                              securityDialogData.groupManagement
                                .selectedGroupData.GroupDescription
                            "
                          ></textarea>
                        </div>
                      </div>
                      <div
                        class="form-group"
                        v-if="selectedUserData.ClientGuid"
                      >
                        <label
                          for="securityGroupsIsReportingGroupCheckbox"
                          id="securityGroupsIsReportingGroupCheckboxLabel"
                          class="col-md-3 control-label"
                        >
                          {{ lang.S0191 }}
                          <i class="material-icons md-18">help_outline</i>
                        </label>
                        <div class="col-md-9">
                          <div class="checkbox" style="float: left">
                            <label>
                              <input
                                type="checkbox"
                                id="securityGroupsIsReportingGroupCheckbox"
                                v-model="
                                  securityDialogData.groupManagement
                                    .selectedGroupData.IsReportingGroup
                                "
                                @change="reportingGroupFlagToggled()"
                                :disabled="!findNextFreeTargetGroup()"
                              />
                              <span class="checkbox-material">
                                <span class="check"></span>
                              </span>
                            </label>
                          </div>
                        </div>
                        <b-tooltip
                          ref="tooltip"
                          target="securityGroupsIsReportingGroupCheckboxLabel"
                          placement="left"
                          :delay="globals.tooltipDelay"
                        >
                          {{ lang.S0195 }}
                          <br />
                          <br />
                          {{ lang.S0196 }}
                        </b-tooltip>
                      </div>
                      <div class="form-group">
                        <label
                          for="securityGroupsClientSelect"
                          class="col-md-3 control-label"
                        >
                          {{ lang.S0185 }}
                          <span
                            v-show="
                              securityDialogData.groupManagement
                                .selectedGroupData.IsReportingGroup
                            "
                            >*</span
                          >
                        </label>
                        <div class="col-md-9">
                          <select2
                            id="securityGroupsClientSelect"
                            class="form-control"
                            :allowClear="true"
                            :placeholder="lang.S0186"
                            v-model="
                              securityDialogData.groupManagement
                                .selectedGroupData.ClientGuid
                            "
                            :disabled="
                              securityDialogData.groupManagement
                                .selectedGroupData.IsReportingGroup
                            "
                          >
                            <option
                              v-for="client in clientListWithGuid"
                              :key="client.ClientGuid"
                              :value="client.ClientGuid"
                            >
                              {{ client.ClientName }}
                            </option>
                          </select2>
                        </div>
                      </div>
                      <div
                        class="form-group"
                        v-if="
                          securityDialogData.groupManagement.selectedGroupData
                            .IsReportingGroup
                        "
                      >
                        <label
                          for="targetGroupRadios"
                          class="col-md-3 control-label"
                          >{{ lang.S0197 }}</label
                        >
                        <div class="col-md-9 text-left">
                          <div
                            class="radio"
                            v-for="(tg, guid) in targetGroups"
                            :key="guid"
                          >
                            <label>
                              <input
                                type="radio"
                                name="targetGroupRadios"
                                :id="`targetGroupRadio${tg}`"
                                :value="guid"
                                :checked="
                                  guid ===
                                  securityDialogData.groupManagement
                                    .selectedGroupData.TargetGroupGuid
                                "
                                @change="targetGroupGuidChanged(guid)"
                              />
                              {{ lang.S0197 }} {{ tg }}
                              <span class="circle"></span>
                              <span class="check"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <button
                        type="button"
                        class="btn btn-raised btn-top-bar"
                        @click="clearGroupManagementInputs()"
                      >
                        <i class="material-icons md-36">add_box</i>
                        <br />
                        {{ lang.S0159 }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-raised btn-top-bar"
                        :class="{
                          'btn-warning':
                            securityDialogData.groupManagement
                              .isSelectedGroupDirty,
                        }"
                        :disabled="
                          !securityDialogData.groupManagement.selectedGroupData
                            .GroupName ||
                          (!globals.isAccessAllowed(
                            'LoopOp_SecurityGroups_Create'
                          ) &&
                            !securityDialogData.groupManagement
                              .selectedGroup) ||
                          (!globals.isAccessAllowed(
                            'LoopOp_SecurityGroups_Update'
                          ) &&
                            securityDialogData.groupManagement.selectedGroup)
                        "
                        @click="editGroup()"
                      >
                        <i class="material-icons md-36">save</i>
                        <br />
                        {{ lang.S0082 }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-raised btn-top-bar"
                        :disabled="
                          !securityDialogData.groupManagement.selectedGroup ||
                          !globals.isAccessAllowed(
                            'LoopOp_SecurityGroups_Delete'
                          )
                        "
                        @click="openGroupDeletionDialog()"
                      >
                        <i class="material-icons md-36">clear</i>
                        <br />
                        {{ lang.S0083 }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <!-- Add modal buttons here -->
            <button
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              {{ lang.S0060 }}
            </button>
            <button
              type="button"
              class="btn btn-raised dialog-btn-primary"
              @click="saveSecurityData()"
            >
              {{ lang.S0061 }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- This modal is for security information of users -->
    <div
      class="modal fade"
      id="security2Dialog"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <!-- Modal title -->
            <h4 class="modal-title">
              <b>{{ lang.S0161 }}</b>
            </h4>
            <p>{{ getSelectedUserInfoText() }}</p>
            <div class="form-group">
              <!-- 
                Don't know why this is here :
                
                <select2
                id="security2DialogClientSelect"
                class="form-control"
                :placeholder="selectedUserData.Company"
                :width="'50%'"
                :allowClear="true"
                disabled
              >
                <option></option>
                <option
                  v-for="client in clientList"
                  :key="client.ClientId"
                  :value="parseInt(client.ClientId)"
                >{{ client.ClientName }}</option>
              </select2> -->

              <a
                role="button"
                class="btn btn-default"
                style="margin: 7px 0 0 0; padding: 2px 20px; position: absolute"
                v-if="
                  selectedSecurity2Page === 'locations2Tab' &&
                  security2DialogData.dataLists.locations.length > 100
                "
                @click="
                  (security2DialogData.showTop100LocationsOnly =
                    !security2DialogData.showTop100LocationsOnly),
                    filterLocationData()
                "
              >
                <i
                  class="material-icons md-24 text-primary"
                  v-if="security2DialogData.showTop100LocationsOnly"
                  >check_box</i
                >
                <i class="material-icons md-24 text-primary" v-else
                  >check_box_outline_blank</i
                >
                {{ lang.S0173 }}
              </a>
            </div>
            <div>
              <a
                role="button"
                class="btn btn-default"
                @click="
                  security2DialogData.hasAccessToAllLocations =
                    !security2DialogData.hasAccessToAllLocations
                "
                style="margin: 0"
              >
                <i
                  class="material-icons md-24 text-primary"
                  v-if="security2DialogData.hasAccessToAllLocations"
                  >check_box</i
                >
                <i class="material-icons md-24 text-primary" v-else
                  >check_box_outline_blank</i
                >
                {{ lang.S0189 }}
              </a>
            </div>
          </div>
          <div class="modal-body">
            <ul class="nav nav-tabs nav-security" style="margin-bottom: 15px">
              <li class="active">
                <a
                  href="#clientSettings2Tab"
                  data-toggle="tab"
                  @click="selectedSecurity2Page = 'clientSettings2Tab'"
                  >{{ lang.S0139 }}</a
                >
              </li>
              <li>
                <a
                  href="#locationProperties2Tab"
                  data-toggle="tab"
                  @click="selectedSecurity2Page = 'locationProperties2Tab'"
                  >{{ lang.S0140 }}</a
                >
              </li>
              <li>
                <a
                  href="#locations2Tab"
                  data-toggle="tab"
                  @click="selectedSecurity2Page = 'locations2Tab'"
                  >{{ lang.S0141 }}</a
                >
              </li>
              <li>
                <a
                  href="#reportingFeatures2Tab"
                  data-toggle="tab"
                  @click="selectedSecurity2Page = 'reportingFeatures2Tab'"
                  >{{ lang.S0142 }}</a
                >
              </li>
              <!-- <li>
                    <a
                      href="#questions2Tab"
                      data-toggle="tab"
                      @click="selectedSecurity2Page = 'questions2Tab'"
                    >{{lang.S0143}}</a>
              </li>-->
            </ul>
            <div class="tab-content">
              <div class="tab-pane fade in active" id="clientSettings2Tab">
                <div>
                  <table class="table outer-table">
                    <thead>
                      <tr>
                        <!-- <th></th> -->
                        <th class="col-md-8">{{ lang.S0174 }}</th>
                        <th class="col-md-4">{{ lang.S0175 }}</th>
                      </tr>
                    </thead>

                    <tbody class="table-scrollbar">
                      <template
                        v-for="project in security2DialogData.dataLists
                          .clientSetting"
                      >
                        <tr
                          data-toggle="collapse"
                          :data-target="
                            '#securityProjectWaves' + project.ProjectGuid
                          "
                          class="accordion-toggle background-grey"
                          :class="{ 'cursor-pointer': !project.Forbidden }"
                          :key="project.ProjectGuid"
                          @click="
                            (project.expanded = !project.expanded),
                              $forceUpdate()
                          "
                        >
                          <td class="project-name-data">
                            <i class="material-icons" v-show="project.Forbidden"
                              >chevron_right</i
                            >
                            <i
                              class="material-icons"
                              v-show="!project.Forbidden && !project.expanded"
                              >expand_more</i
                            >
                            <i
                              class="material-icons"
                              v-show="!project.Forbidden && project.expanded"
                              >expand_less</i
                            >
                            <span>{{ project.ProjectName }}</span>
                          </td>
                          <td>
                            <div class="checkbox" style="margin: 0px">
                              <label @click.stop="project.expanded = false">
                                <input
                                  type="checkbox"
                                  :id="
                                    'cb_projectForbidden_' + project.ProjectGuid
                                  "
                                  v-model="project.Forbidden"
                                />
                                <span class="checkbox-material">
                                  <span class="check"></span>
                                </span>
                              </label>
                              <i
                                class="material-icons"
                                v-show="hasForbiddenWaves(project)"
                                >priority_high</i
                              >
                            </div>
                          </td>
                        </tr>
                        <tr
                          :key="project.ProjectGuid + 'waves'"
                          v-if="!project.Forbidden"
                        >
                          <td colspan="2" class="hiddenRow">
                            <div
                              :id="'securityProjectWaves' + project.ProjectGuid"
                              class="accordion-body collapse"
                            >
                              <span
                                style="margin-left: 30px"
                                v-if="
                                  !project.Waves || project.Waves.length < 1
                                "
                                >{{ lang.S0176 }}</span
                              >
                              <table
                                class="table table-hover inner-table"
                                v-else
                              >
                                <thead>
                                  <tr>
                                    <th class="col-md-8">{{ lang.S0177 }}</th>
                                    <th class="col-md-4">{{ lang.S0175 }}</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  <tr
                                    v-for="wave in project.Waves"
                                    :key="wave.WaveGuid"
                                  >
                                    <td>{{ wave.WaveName }}</td>
                                    <td>
                                      <div class="checkbox" style="margin: 0px">
                                        <label @click.stop>
                                          <input
                                            type="checkbox"
                                            :id="
                                              'cb_waveForbidden_' +
                                              wave.WaveGuid
                                            "
                                            v-model="wave.Forbidden"
                                          />
                                          <span class="checkbox-material">
                                            <span class="check"></span>
                                          </span>
                                        </label>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="tab-pane fade in" id="locationProperties2Tab">
                <div v-show="security2DialogData.hasAccessToAllLocations">
                  {{ lang.S0190 }}
                </div>
                <div
                  v-show="
                    !security2DialogData.hasAccessToAllLocations &&
                    selectedUserData.ClientGuid
                  "
                >
                  <CustomPropertiesPoliciesControl
                    :key="selectedUserData.ClientGuid"
                    ref="locationProperties2Tab"
                    :lang="lang"
                    :user="selectedUserData"
                    :selectedClient="selectedUserData.ClientGuid"
                  />
                </div>
              </div>

              <div class="tab-pane fade in" id="locations2Tab">
                <div v-show="security2DialogData.hasAccessToAllLocations">
                  {{ lang.S0190 }}
                </div>
                <div v-show="!security2DialogData.hasAccessToAllLocations">
                  <div class="table-space main-table-scrollbar">
                    <table>
                      <tr>
                        <table
                          class="table table-striped table-hover main-table"
                        >
                          <thead>
                            <tr>
                              <th class="text-center sticky-header">
                                {{ lang.S0166 }}
                              </th>
                              <th class="text-center sticky-header">
                                {{ lang.S0169 }}
                              </th>
                              <th class="text-center sticky-header">
                                {{ lang.S0168 }}
                              </th>
                              <th class="text-center sticky-header">
                                {{ lang.S0179 }}
                              </th>
                              <th class="text-center sticky-header">
                                {{ lang.S0167 }}
                              </th>
                              <th class="text-center sticky-header">
                                {{ lang.S0172 }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td class="nopadding sticky-filter">
                                <div class="form-group filterbar">
                                  <input
                                    type="search"
                                    class="form-control text-center nopadding"
                                    :placeholder="lang.S0018"
                                    v-model="
                                      security2DialogData.locationFilterStrings
                                        .LocationStoreId
                                    "
                                    @keyup.enter="filterLocationData()"
                                  />
                                </div>
                              </td>
                              <td class="nopadding sticky-filter">
                                <div class="form-group filterbar">
                                  <input
                                    type="search"
                                    class="form-control text-center nopadding"
                                    :placeholder="lang.S0018"
                                    v-model="
                                      security2DialogData.locationFilterStrings
                                        .LocationName
                                    "
                                    @keyup.enter="filterLocationData()"
                                  />
                                </div>
                              </td>
                              <td class="nopadding sticky-filter">
                                <div class="form-group filterbar">
                                  <input
                                    type="search"
                                    class="form-control text-center nopadding"
                                    :placeholder="lang.S0018"
                                    v-model="
                                      security2DialogData.locationFilterStrings
                                        .LocationAddress
                                    "
                                    @keyup.enter="filterLocationData()"
                                  />
                                </div>
                              </td>
                              <td class="nopadding sticky-filter">
                                <div class="form-group filterbar">
                                  <input
                                    type="search"
                                    class="form-control text-center nopadding"
                                    :placeholder="lang.S0018"
                                    v-model="
                                      security2DialogData.locationFilterStrings
                                        .LocationCountry
                                    "
                                    @keyup.enter="filterLocationData()"
                                  />
                                </div>
                              </td>
                              <td class="nopadding sticky-filter">
                                <div class="form-group filterbar">
                                  <input
                                    type="search"
                                    class="form-control text-center nopadding"
                                    :placeholder="lang.S0018"
                                    v-model="
                                      security2DialogData.locationFilterStrings
                                        .LocationStatusId
                                    "
                                    @keyup.enter="filterLocationData()"
                                  />
                                </div>
                              </td>
                              <td class="nopadding sticky-filter">
                                <div class="form-group filterbar">
                                  <a
                                    role="button"
                                    @click="
                                      (security2DialogData.locationFilterStrings.LocationVisible =
                                        (security2DialogData
                                          .locationFilterStrings
                                          .LocationVisible +
                                          1) %
                                        3),
                                        filterLocationData()
                                    "
                                  >
                                    <div
                                      class="cb-active-filter-container"
                                      v-if="
                                        security2DialogData
                                          .locationFilterStrings
                                          .LocationVisible == 1
                                      "
                                    >
                                      <i class="material-icons md-24"
                                        >check_box</i
                                      >
                                    </div>
                                    <div
                                      class="cb-active-filter-container"
                                      v-else-if="
                                        security2DialogData
                                          .locationFilterStrings
                                          .LocationVisible == 0
                                      "
                                    >
                                      <i class="material-icons md-24"
                                        >check_box_outline_blank</i
                                      >
                                    </div>
                                    <div
                                      class="cb-active-filter-container"
                                      v-else
                                    >
                                      <i class="material-icons md-24"
                                        >indeterminate_check_box</i
                                      >
                                    </div>
                                  </a>
                                </div>
                              </td>
                            </tr>
                            <tr
                              v-for="location in security2DialogData.dataLists
                                .filteredLocations"
                              :key="location.LocationId"
                            >
                              <td>
                                {{ location.LocationStoreId }}
                              </td>
                              <td>
                                {{ location.LocationName }}
                              </td>
                              <td>
                                {{ location.LocationAddress }}
                              </td>
                              <td>
                                {{ location.LocationCountry }}
                              </td>
                              <td>
                                {{ location.LocationStatusId }}
                              </td>
                              <td>
                                <a
                                  class="btn-default btn-cb-policies"
                                  @click="
                                    toggleLocationPermission(
                                      location.LocationGuid
                                    )
                                  "
                                >
                                  <i
                                    class="material-icons md-24 text-primary"
                                    v-if="
                                      isLocationPermitted(location.LocationGuid)
                                    "
                                    >check_box</i
                                  >
                                  <i
                                    class="material-icons md-24 text-primary"
                                    v-else
                                    >check_box_outline_blank</i
                                  >
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>

              <div class="tab-pane fade in" id="reportingFeatures2Tab">
                <!-- <div v-show="!isAnyClientSelected()">
                      <h4>{{lang.S0158}}</h4>
                </div>-->
                <div>
                  <SettingsPoliciesControl
                    ref="reportingFeatures2Tab"
                    :lang="lang"
                    :user="selectedUserData"
                  />
                </div>
              </div>

              <!-- <div class="tab-pane fade in" id="questions2Tab">
                    <div>
                      <SurveysQuestionsPoliciesControl
                        ref="questions2Tab"
                        :lang="lang"
                        :user="selectedUserData"
                        :clients="getSelectedClients()"
                      />
                    </div>
              </div>-->
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              {{ lang.S0164 }}
            </button>
            <button
              type="button"
              class="btn btn-raised dialog-btn-primary"
              @click="saveSecurity2Data()"
            >
              {{ lang.S0061 }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- This modal is for the security check if a user tries to delete any user -->
    <div
      class="modal fade"
      id="deleteUserDialog"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <!-- Modal title -->
            <h4 class="modal-title">
              <b>{{ lang.S0099 }}</b>
            </h4>
          </div>
          <div class="modal-body">
            <p>
              <b>{{ lang.S0100 }}</b>
            </p>
            <!-- Location data is displayed here to let the user know which location he is about to delete -->
            <div class="form-group">
              <label class="col-md-3 text-black">{{ lang.S0020 }}</label>
              <label class="col-md-9 text-black">{{
                deleteUserDialogData.LoginName
              }}</label>
            </div>
            <div class="form-group">
              <label class="col-md-3 text-black">{{ lang.S0022 }}</label>
              <label class="col-md-9 text-black">{{
                deleteUserDialogData.FirstName
              }}</label>
            </div>
            <div class="form-group">
              <label class="col-md-3 text-black">{{ lang.S0023 }}</label>
              <label class="col-md-9 text-black">{{
                deleteUserDialogData.LastName
              }}</label>
            </div>
            <div class="form-group">
              <label class="col-md-3 text-black">{{ lang.S0009 }}</label>
              <label class="col-md-9 text-black">{{
                deleteUserDialogData.RoleType
              }}</label>
            </div>
            <div class="form-group">
              <label class="col-md-3 text-black">{{ lang.S0133 }}</label>
              <label class="col-md-9 text-black">{{
                deleteUserDialogData.Role
              }}</label>
            </div>
          </div>
          <div class="modal-footer">
            <!-- Add modal buttons here -->
            <button
              id="user-management-modal-delete-false-button"
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              {{ lang.S0102 }}
            </button>
            <button
              id="user-management-modal-delete-true-button"
              type="button"
              class="btn btn-raised btn-warning"
              @click="deleteUserData()"
            >
              {{ lang.S0101 }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <change-password-dialog
      :showDialog="showChangePasswordDialog"
      :userGuid="selectedUser"
      :userName="selectedUserData.LoginName"
      @dialogClosed="onChangePasswordDialogClosed"
    ></change-password-dialog>
  </div>
</template>

<script>
import ImportUsersModal from "@/components/ImportUsersModal";
import SettingsPoliciesControl from "./UserMgmt/SettingsPoliciesControl";
import CustomPropertiesPoliciesControl from "./UserMgmt/CustomPropertiesPoliciesControl";
import SurveysQuestionsPoliciesControl from "./UserMgmt/SurveysQuestionsPoliciesControl";
import Select2 from "./Tools/Select2";
import ConfirmationDialog from "./Tools/Dialogs/ConfirmationDialog";
import ChangePasswordDialog from "./Tools/Dialogs/ChangePasswordDialog";

import UseUserSecurity from "../services/UserSecurity";

import policiesMixin from "../mixins/policiesmixin";

export default {
  name: "UserManagement",
  components: {
    SettingsPoliciesControl,
    CustomPropertiesPoliciesControl,
    SurveysQuestionsPoliciesControl,
    ImportUsersModal,
    Select2,
    ConfirmationDialog,
    "change-password-dialog": ChangePasswordDialog,
  },
  mixins: [policiesMixin],
  mounted() {
    this.readComponentSettingsFromStore();
    // Gets executed right after rendering the component
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.getUserData();
    }
    this.getEditUserDialogSelectData();
    this.getTargetGroups();

    $('a[data-toggle="tab"]').on("hidden.bs.tab", (e) => {
      // Removes selected items on the security dialog after switching the tab
      this.securityDialogData.selectedAssignedGroupGuids = [];
      this.securityDialogData.selectedUnassignedGroupGuids = [];
    });

    $(window).on("resize", this.setTableHeight).resize();

    if (!this.globals.currentUserInfo)
      this.globals.$once("currentUserInfoReceived", this.setTableHeight);

    this.globals.$off("SecurityGroupDeleteModalYesConfirmation");
    this.globals.$on("SecurityGroupDeleteModalYesConfirmation", () => {
      this.deleteSelectedGroup();
    });
  },
  destroyed() {
    $(window).off("resize", this.setTableHeight);
    this.writeComponentSettingsToStore();
  },
  computed: {
    clientListNumberd() {
      return this.clientList.map((client) => ({
        ClientId: Number(client.ClientId),
        ClientName: client.ClientName,
      }));
    },
    // List of security groups that are assigned to the current user
    groupListAssigned() {
      return this.securityDialogData.dataLists.customGroupData.filter(
        (g) =>
          this.securityDialogData.assignedGroupGuids.indexOf(g.GroupGuid) > -1
      );
    },
    // List of available security groups that are not assigned to the current user
    groupListAvailable() {
      return this.securityDialogData.dataLists.customGroupData.filter(
        (g) =>
          this.securityDialogData.assignedGroupGuids.indexOf(g.GroupGuid) < 0
      );
    },
  },
  methods: {
    setTableHeight() {
      this.$nextTick(() => {
        let height = $(window).height();
        height -=
          $("#users-top-panel").height() +
          $("#app-navbar").height() +
          //$(".main-table > thead").height() +
          47; // 47 pixel for the free space around the cards
        $(".main-table-scrollbar").css("max-height", height);
        $(".table-space").css("max-height", height);

        height -= 100; // Lower height for client policies table because of dialog size limitations
        $(".client-policies-table").css("max-height", height);
        $("#locations2Tab .main-table-scrollbar").css("max-height", height);

        //Sets top-property for filter, so it doesnt scroll over table-header
        height = $(".main-table thead tr").height();
        $(".sticky-filter").css("top", height);
      });
    },
    readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      let storedData = this.$store.getters["localFilters/userManagement"];
      if (storedData) {
        for (let key in storedData) {
          if (_.has(this, key)) this[key] = _.cloneDeep(storedData[key]);
        }
      }

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (
        !this.feature.isAudiTarget ||
        !this.feature.isEnabled("audi_importers")
      ) {
        let storedClient = this.$store.getters["sharedFilters/client"];
        this.filterStrings.Company = storedClient.ClientName || "";
      }
    },
    writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/userManagement", {
        filterStrings: this.filterStrings,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pageSize: this.pageSize,
      });
    },
    // Validates an input with the given id, changes the input color depending on the validation result and returns the result
    validateInput(id) {
      var result = $("#" + id)[0].checkValidity(); // Checks validation depending on the input type or a given pattern in the template
      if (result) {
        $("#" + id)
          .parent()
          .parent()
          .removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id)
          .parent()
          .parent()
          .addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },
    // Returns true if an input has a validation error, otherwise false
    inputHasError(id) {
      if (this.invalidInputIds.indexOf(id) > -1) return true;
      return false;
    },
    // returns user info text in format:
    // "Benutzername: Lastname, Firstname (Username); Benutzer-ID: {GUID}; Typ: {UserType}"
    getSelectedUserInfoText() {
      let usr = this.selectedUserData;
      if (!usr) return "user informations unknown";
      let infoText = `${this.lang.S0178}: ${usr.LastName}, ${usr.FirstName} (${usr.LoginName}); ${this.lang.S0009}:${usr.RoleType}:${usr.Role}`;
      if (usr.Company) infoText += ` - ${usr.Company}`;
      return infoText;
    },
    // Triggers input validation and ensures further progress if validation was successful
    validateBeforeSubmit(dialogId) {
      var result = true;

      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0)
          // escape special characters, because the ID is used in selector (this is a quick fix for #editUserDialogData.userData.RoleTypeGuid)
          result =
            this.validateInput(elements[i].id.replaceAll(".", "\\.")) && result; // If only one input is invalid, the whole form is invalid
      }

      if (dialogId == "editUser") {
        this.editUserDialogData.showAlert = !result;
        if (!result) return;
        this.saveEditUserDialogData();
      }
    },
    // Resets all validation errors for the given dialog
    resetValidationErrors(dialogId) {
      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0)
          $("#" + elements[i].id)
            .parent()
            .parent()
            .removeClass("has-error");
      }
      this.invalidInputIds = [];
    },

    // Open history
    showUserHistory() {
      let config = {
        type: "User",
        guid: this.editUserDialogData.userData.UserId, // here UserId is User Guid
        id: this.editUserDialogData.userData.UserId,
      };
      this.globals.$emit("showElementHistory", config);
    },

    // Opens the security check dialog for deleting the selected user
    openDeleteUserDialog() {
      var objIndex = _.findIndex(this.userData, (o) => {
        return o.UserId == this.selectedUser;
      });
      this.deleteUserDialogData = this.userData[objIndex];
      $("#deleteUserDialog").modal("show");
    },
    // Sends a delete request for the selected user to the server
    deleteUserData() {
      $.ajax({
        method: "DELETE",
        url: "api/SecurityUsers/" + this.selectedUser,
        success: (data) => {
          if (data.Error) {
            this.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          // If delete was successful, refresh displayed data and hide dialog
          this.globals.showSuccessSnackbar("User deletion successful");
          $("#deleteUserDialog").modal("hide");
          this.selectedUser = "";
          this.getUserData();
        },
        error: () => {
          console.error("User data deletion failed in deleteUserData()");
          this.globals.showErrorSnackbar("User deletion failed");
        },
      });
    },
    // Refreshes the region list in the dropdown of the editUser dialog depending on the selected country
    changedCountry(country) {
      var regionObj = [{ Regions: [] }];
      var tzObj = [{ TimeZones: [] }];

      if (typeof this.regionList != "undefined") {
        if (typeof country != "undefined" && country != "" && country != "  ") {
          regionObj = this.regionList.filter((region) => {
            // Filter regions for the given country
            return (
              region.CountryCode.toLowerCase().indexOf(country.toLowerCase()) >=
              0
            );
          });
        }
      }

      if (typeof this.timeZones != "undefined") {
        if (typeof country != "undefined" && country != "" && country != "  ") {
          tzObj = this.timeZones.filter((tz) => {
            // Filter timezones for the given country
            return tz.Country.toLowerCase().indexOf(country.toLowerCase()) >= 0;
          });
        }
      }

      if (regionObj.length == 0) this.editUserDialogData.currentRegions = [];
      else this.editUserDialogData.currentRegions = regionObj[0].Regions;

      if (tzObj.length == 0) this.editUserDialogData.currentTimeZones = [];
      else this.editUserDialogData.currentTimeZones = tzObj[0].TimeZones;

      var idx = this.editUserDialogData.currentRegions
        .map((e) => {
          return e.RegionGuid;
        })
        .indexOf(this.editUserDialogData.userData.RegionGuid);

      if (idx < 0) delete this.editUserDialogData.userData.RegionGuid;

      idx = this.editUserDialogData.currentTimeZones
        .map((e) => {
          return e.TimeZoneId;
        })
        .indexOf(this.editUserDialogData.userData.TimeZone);

      if (idx < 0) delete this.editUserDialogData.userData.TimeZone;
    },
    roleTypeChanged() {
      delete this.editUserDialogData.userData.AgencyGuid;
      delete this.editUserDialogData.userData.ClientId;
      delete this.editUserDialogData.userData.RoleGuid;
      this.setCurrentRoles();
      this.$forceUpdate();
    },
    setCurrentRoles() {
      this.editUserDialogData.currentRoles = [];
      if (!this.editUserDialogData.userData.RoleTypeGuid || !this.roleData[0])
        return;

      let rtData = _.find(
        this.roleData,
        (rt) =>
          rt.RoleTypeGuid === this.editUserDialogData.userData.RoleTypeGuid
      );
      if (rtData && rtData.Roles) {
        this.editUserDialogData.currentRoles = rtData.Roles;
        if (rtData.Roles.length === 1)
          this.editUserDialogData.userData.RoleGuid = rtData.Roles[0].RoleGuid;

        //this.$refs.editUserSelectRole.updateValue();
      }
    },
    securityDialogDataReceived() {
      $("#securityDialog").modal("show");
    },
    openSecurityDialog() {
      var doneCounter = 0;
      var requestCount = 2;

      this.securityDialogData.dataLists.securityGroupData = [];
      this.securityDialogData.dataLists.roleData = [];
      this.securityDialogData.dataLists.customGroupData = [];
      this.securityDialogData.assignedGroupGuids = [];
      this.securityDialogData.selectedAssignedGroupGuids = [];
      this.securityDialogData.selectedUnassignedGroupGuids = [];
      this.clearGroupManagementInputs();

      let query = `api/SecurityGroups`;
      if (this.selectedUserData.ClientGuid)
        query += `?ClientGuid=${this.selectedUserData.ClientGuid}`;

      $.ajax({
        method: "GET",
        url: query,
        success: (data) => {
          let sortedData = _.sortBy(data, [(g) => g.GroupName.toLowerCase()]);
          // Request general group informations
          for (let group of sortedData) {
            // Copy group data to different lists for roles, security groups and custom groups
            if (group.GroupType === "SM")
              this.securityDialogData.dataLists.securityGroupData.push(group);
            else if (group.GroupType === "SYSTEM")
              this.securityDialogData.dataLists.roleData.push(group);
            else if (group.GroupType === "SMUSER")
              this.securityDialogData.dataLists.customGroupData.push(group);
          }
        },
        error: () => {
          console.error("Group data access failed in openSecurityDialog()");
          this.globals.showErrorSnackbar("Group data access failed");
          doneCounter = -1;
        },
        complete: () => {
          doneCounter++;
          if (doneCounter >= requestCount) this.securityDialogDataReceived();
        },
      });

      $.ajax({
        method: "GET",
        url: `api/SecurityUsers/${this.selectedUser}/Groups`,
        success: (data) => {
          // Request groups that are assigned to current user
          this.securityDialogData.assignedGroupGuids = data;
        },
        error: () => {
          console.error(
            "Group assignment data access failed in openSecurityDialog()"
          );
          this.globals.showErrorSnackbar("Group assignment data access failed");
          doneCounter = -1;
        },
        complete: () => {
          doneCounter++;
          if (doneCounter >= requestCount) this.securityDialogDataReceived();
        },
      });
    },
    getAllSecurityGroups() {
      let query = `api/SecurityGroups`;
      if (this.selectedUserData.ClientGuid)
        query += `?ClientGuid=${this.selectedUserData.ClientGuid}`;

      $.ajax({
        method: "GET",
        url: query,
        success: (data) => {
          this.securityDialogData.dataLists.securityGroupData = [];
          this.securityDialogData.dataLists.roleData = [];
          this.securityDialogData.dataLists.customGroupData = [];

          let sortedData = _.sortBy(data, [(g) => g.GroupName.toLowerCase()]);
          for (let group of sortedData) {
            // Copy group data to different lists for roles, security groups and custom groups
            if (group.GroupType === "SM")
              this.securityDialogData.dataLists.securityGroupData.push(group);
            else if (group.GroupType === "SYSTEM")
              this.securityDialogData.dataLists.roleData.push(group);
            else if (group.GroupType === "SMUSER")
              this.securityDialogData.dataLists.customGroupData.push(group);
          }
        },
        error: () => {
          console.error("Group data access failed in getAllSecurityGroups()");
          this.globals.showErrorSnackbar("Group data access failed");
        },
      });
    },
    getSecurityGroupData() {
      $.ajax({
        method: "GET",
        url: `api/SecurityGroups/${this.securityDialogData.groupManagement.selectedGroup}`,
        success: (data) => {
          // Request groups that are assigned to current user
          this.securityDialogData.groupManagement.selectedGroupData = data;
        },
        error: () => {
          console.error("Group data access failed in getSecurityGroupData()");
          this.globals.showErrorSnackbar("Group data access failed");
        },
      });
    },
    getTargetGroups() {
      let query = "api/Data/TargetGroups";

      $.ajax({
        method: "GET",
        url: query,
        success: (data) => {
          this.targetGroups = data;
        },
        error: () => {
          console.error("Target group data access failed in getTargetGroups()");
          this.globals.showErrorSnackbar("Target group data access failed");
        },
      });
    },
    targetGroupGuidChanged(targetGroupGuid) {
      let groupGuid = this.isTargetGroupAlreadyInUse(targetGroupGuid);
      if (
        groupGuid &&
        groupGuid !==
          this.securityDialogData.groupManagement.selectedGroupData.GroupGuid
      ) {
        this.globals.$emit("openGlobalNotificationDialog", {
          initiator: "GroupManagementTargetGroupChange",
          notificationTitle: this.lang.S0198,
          colorRed: true,
          closeButtonText: this.lang.S0164,
          htmlText: `<b>
            <p>${this.lang.S0199}</p>
          </b>`,
        });
      }
      this.securityDialogData.groupManagement.selectedGroupData.TargetGroupGuid =
        targetGroupGuid;
    },
    // Returns GUID of the group that uses the target group
    isTargetGroupAlreadyInUse(targetGroupGuid) {
      if (this.securityDialogData.dataLists.customGroupData.length < 1)
        return "";

      let group = _.find(this.securityDialogData.dataLists.customGroupData, [
        "TargetGroupGuid",
        targetGroupGuid,
      ]);
      return group ? group.GroupGuid : "";
    },
    findNextFreeTargetGroup() {
      if (
        this.securityDialogData.groupManagement.selectedGroupData
          .TargetGroupGuid
      )
        return this.securityDialogData.groupManagement.selectedGroupData
          .TargetGroupGuid;

      for (let tg in this.targetGroups) {
        if (!this.isTargetGroupAlreadyInUse(tg)) return tg;
      }
      return "";
    },
    reportingGroupFlagToggled() {
      if (
        this.securityDialogData.groupManagement.selectedGroupData
          .IsReportingGroup
      ) {
        if (this.selectedUserData.ClientGuid) {
          this.securityDialogData.groupManagement.selectedGroupData.ClientGuid =
            this.selectedUserData.ClientGuid;
          this.securityDialogData.groupManagement.selectedGroupData.TargetGroupGuid =
            this.findNextFreeTargetGroup();
          this.$forceUpdate();
        }
      }
    },
    getSelectedClients() {
      //return this.security2DialogData.dataLists.selectedClients.filter(i => {return i.Permitted})
      return this.security2DialogData.dataLists.selectedClients.filter((i) => {
        return i.Permitted;
      });
    },
    // Opens the securityDialog after the dialog data is received
    security2DialogDataReceived() {
      $("#security2Dialog").modal("show");
    },
    //Apply filters for Location Data
    filterLocationData() {
      let keys = [
        "LocationStoreId",
        "LocationName",
        "LocationAddress",
        "LocationCountry",
        "LocationStatusId",
      ];
      let filterStrings = this.security2DialogData.locationFilterStrings;
      let permittedLocations =
        this.security2DialogData.dataLists.permittedLocations;

      const locationFilter = (location) => {
        let filterPassed = true;

        // Filter for location permission
        let locationPermitted =
          _.indexOf(permittedLocations, location.LocationGuid) > -1;
        if (
          (filterStrings.LocationVisible === 0 && locationPermitted) ||
          (filterStrings.LocationVisible === 1 && !locationPermitted)
        )
          return false;

        // Filter for filterstrings
        keys.forEach((key) => {
          if (
            typeof location[key] === "string" &&
            location[key]
              .toLowerCase()
              .indexOf(filterStrings[key].toLowerCase()) < 0
          ) {
            filterPassed = false;
            return;
          }
        });
        return filterPassed;
      };

      let filteredLocations = !_.isEmpty(
        this.security2DialogData.dataLists.locations
      )
        ? this.security2DialogData.dataLists.locations.filter(locationFilter)
        : [];

      // Filter top 100
      if (
        this.security2DialogData.showTop100LocationsOnly &&
        filteredLocations.length > 100
      )
        filteredLocations = filteredLocations.slice(0, 100);

      this.security2DialogData.dataLists.filteredLocations = filteredLocations;
    },
    // Requests needed group data for the security dialog from the server
    openSecurity2Dialog() {
      let requestCount = 4;
      let successCallback = () => {
        if (--requestCount === 0) {
          this.security2DialogDataReceived();
        }
      };
      let errorCallback = () => {
        this.globals.showErrorSnackbar("Policy data request failed");
      };

      this.security2DialogData.dataLists.selectedClients = [];
      this.security2DialogData.dataLists.clientSetting = [];
      this.security2DialogData.dataLists.locationProperties = [];
      this.security2DialogData.dataLists.locations = [];
      this.security2DialogData.hasAccessToAllLocations = false;

      // this.$refs.questions2Tab.loadPolicies();
      if (!this.security2DialogData.hasAccessToAllLocations)
        this.$refs.locationProperties2Tab.loadPolicies(
          successCallback,
          errorCallback
        );
      this.$refs.reportingFeatures2Tab.loadPolicies(
        successCallback,
        errorCallback
      );

      $.ajax({
        method: "GET",
        url: `/api/UserSecurity/${this.selectedUser}/Clients`,
        success: (data) => {
          if (
            data &&
            data[0] &&
            data[0].ClientGuid &&
            data[0].ClientGuid === this.selectedUserData.ClientGuid &&
            data[0].Permitted === true
          ) {
            this.security2DialogData.hasAccessToAllLocations = true;
          }
          successCallback();
        },
        error: () => {
          console.error("Client data access failed in openSecurity2Dialog()");
          errorCallback();
        },
      });

      $.ajax({
        method: "GET",
        url: `/api/UserSecurity/${this.selectedUser}/Projects/Client/${this.selectedUserData.ClientGuid}`,
        success: (data) => {
          this.security2DialogData.dataLists.clientSetting = _.isEmpty(data)
            ? []
            : data;
          successCallback();
        },
        error: () => {
          console.error("Project data access failed in openSecurity2Dialog()");
          errorCallback();
        },
      });

      $.ajax({
        method: "GET",
        url: `/api/UserSecurity/${this.selectedUser}/Locations/Client/${this.selectedUserData.ClientGuid}`,
        success: (data) => {
          if (data && data[0]) {
            if (data[0].Locations)
              this.security2DialogData.dataLists.locations = data[0].Locations;
            else this.security2DialogData.dataLists.locations = [];

            if (data[0].Permitted)
              this.security2DialogData.dataLists.permittedLocations =
                data[0].Permitted;
            else this.security2DialogData.dataLists.permittedLocations = [];

            this.filterLocationData();
          }
          successCallback();
        },
        error: () => {
          console.error("Location data access failed in openSecurity2Dialog()");
          errorCallback();
        },
      });
    },
    toggleLocationPermission(locGuid) {
      this.security2DialogData.dataLists.permittedLocations = _.xor(
        this.security2DialogData.dataLists.permittedLocations,
        [locGuid]
      );
    },
    isLocationPermitted(locGuid) {
      return (
        _.indexOf(
          this.security2DialogData.dataLists.permittedLocations,
          locGuid
        ) > -1
      );
    },
    // Adds a new item to a list if it's not already in the list. Otherwise the item will me removed from the list.
    toggleListItem(list, item) {
      let index = list.indexOf(item);
      if (index > -1) {
        list.splice(index, 1);
      } else list.push(item);
    },
    // Assigns selected groups to the user
    assignGroups() {
      if (this.securityDialogData.selectedUnassignedGroupGuids.length == 0)
        return;
      for (
        var i = 0;
        i < this.securityDialogData.selectedUnassignedGroupGuids.length;
        i++
      ) {
        this.securityDialogData.assignedGroupGuids.push(
          this.securityDialogData.selectedUnassignedGroupGuids[i]
        );
      }
      this.securityDialogData.selectedUnassignedGroupGuids = [];
    },
    // Unassigns selected groups from the user
    unassignGroups() {
      if (this.securityDialogData.selectedAssignedGroupGuids.length == 0)
        return;
      for (
        var i = 0;
        i < this.securityDialogData.selectedAssignedGroupGuids.length;
        i++
      ) {
        var index = this.securityDialogData.assignedGroupGuids.indexOf(
          this.securityDialogData.selectedAssignedGroupGuids[i]
        );
        this.securityDialogData.assignedGroupGuids.splice(index, 1);
      }
      this.securityDialogData.selectedAssignedGroupGuids = [];
    },
    // Edits a custom group to the group list or adds a new group if the group does not exist
    editGroup() {
      if (
        !this.securityDialogData.groupManagement.selectedGroupData
          .IsReportingGroup
      )
        delete this.securityDialogData.groupManagement.selectedGroupData
          .TargetGroupGuid;

      let groupData = _.cloneDeep(
        this.securityDialogData.groupManagement.selectedGroupData
      );
      if (!groupData.ClientGuid) delete groupData.ClientGuid;

      if (!this.securityDialogData.groupManagement.selectedGroup) {
        $.ajax({
          // Stores a new group on the server
          method: "POST",
          url: "api/SecurityGroups",
          data: JSON.stringify(groupData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            if (!data || _.isEmpty(data)) {
              console.error("No valid group data returned in editGroup()");
              return;
            }
            if (data.Error) {
              this.globals.showErrorSnackbar(data.Error);
              return;
            }
            // If POST was successful, store new data to local datalist and select the new group
            this.globals.showSuccessSnackbar("Group creation successful");
            groupData = data;
            this.getAllSecurityGroups();
            this.securityDialogData.groupManagement.selectedGroup =
              groupData.GroupGuid;
            this.securityDialogData.groupManagement.selectedGroupData =
              groupData;
            this.securityDialogData.groupManagement.isSelectedGroupDirty = false;
          },
          error: () => {
            console.error("Error on POST in editGroup()");
            this.globals.showErrorSnackbar("Group creation failed");
          },
        });
      } else {
        $.ajax({
          // Stores changes of a group on the server
          method: "PUT",
          url:
            "api/SecurityGroups/" +
            this.securityDialogData.groupManagement.selectedGroup,
          data: JSON.stringify(groupData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            if (data.Error) {
              this.globals.showErrorSnackbar(data.Error);
              return;
            }
            // If PUT was successful, store data to local datalist and select the new group
            this.globals.showSuccessSnackbar("Group update successful");
            let updatedGroupIndex = _.findIndex(
              this.securityDialogData.dataLists.customGroupData,
              [
                "GroupGuid",
                this.securityDialogData.groupManagement.selectedGroup,
              ]
            );

            this.getAllSecurityGroups();
            this.securityDialogData.groupManagement.isSelectedGroupDirty = false;
            this.$forceUpdate();
          },
          error: () => {
            console.error("Error on PUT in editGroup()");
            this.globals.showErrorSnackbar("Group update failed");
          },
        });
      }
    },
    // Selects the group with the given ID and fills groupmanagement data fields depending on the selected group
    selectGroup(groupGuid) {
      if (this.securityDialogData.groupManagement.selectedGroup === groupGuid) {
        this.clearGroupManagementInputs();
      } else {
        this.securityDialogData.groupManagement.selectedGroup = groupGuid;
        this.getSecurityGroupData();
      }
    },
    openGroupDeletionDialog() {
      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "SecurityGroupDeleteModal",
        confirmationTitle: this.lang.S0192,
        colorRed: true,
        yesButtonText: this.lang.S0101,
        noButtonText: this.lang.S0102,
        htmlText: `<p><b>${this.lang.S0193}</b></p>
          <div class="form-group">
            <label class="col-md-3 text-black">${this.lang.S0194}</label>
            <label class="col-md-9 text-black">${this.securityDialogData.groupManagement.selectedGroupData.GroupName}</label>
          </div>`,
      });
    },
    // Removes the selected group from the list of custom groups
    deleteSelectedGroup() {
      $.ajax({
        // Stores a new group on the server
        method: "DELETE",
        url:
          "api/SecurityGroups/" +
          this.securityDialogData.groupManagement.selectedGroup,
        data: {},
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          // If DELETE was successful, remove data from local datalist
          this.globals.showSuccessSnackbar("Group deletion successful");
          this.securityDialogData.dataLists.customGroupData =
            this.securityDialogData.dataLists.customGroupData.filter(
              (e) =>
                e.GroupGuid !==
                this.securityDialogData.groupManagement.selectedGroup
            );
          this.clearGroupManagementInputs();
        },
        error: () => {
          console.error("Error on DELETE in deleteSelectedGroup()");
          this.globals.showErrorSnackbar("Group deletion failed");
        },
      });
    },
    // Clears the input fields in groupmanagement
    clearGroupManagementInputs() {
      this.securityDialogData.groupManagement = {
        selectedGroup: "",
        selectedGroupData: {},
      };
    },
    // Sends data from the security dialog to the server to store it in the database
    saveSecurityData() {
      if (
        this.globals.isAccessAllowed(
          "LoopOp_SecurityUsersSecurityGroups_Update"
        )
      ) {
        $.ajax({
          // Stores groups that are assigned to the selected user
          method: "PUT",
          url: "api/SecurityUsers/" + this.selectedUser + "/Groups",
          data: JSON.stringify(this.securityDialogData.assignedGroupGuids),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            // If PUT was successful, hide dialog
            this.globals.showSuccessSnackbar(
              "Group security update successful"
            );
            $("#securityDialog").modal("hide");
          },
          error: () => {
            console.error("Error on PUT in saveSecurityData()");
            this.globals.showErrorSnackbar("Group security update failed");
          },
        });
      }
    },
    /**
     * turns a functions with an succes and error callback into
     * a promise to await or Promise.all
     * @param {function}  fn
     * @returns {Promise<T>}
     */
    promisfy(fn) {
      return new Promise((resolve, reject) => {
        fn(resolve, reject);
      });
    },
    saveSecurity2Data() {
      const refCallbacks = [this.$refs.reportingFeatures2Tab.saveChanges];
      if (!this.security2DialogData.hasAccessToAllLocations)
        refCallbacks.push(this.$refs.locationProperties2Tab.saveChanges);

      const saveClients = (succ, onerror) => {
        let clients = [];
        if (this.security2DialogData.hasAccessToAllLocations)
          clients.push(this.selectedUserData.ClientGuid);
        $.ajax({
          method: "PUT",
          url: `api/UserSecurity/${this.selectedUser}/Clients`,
          data: JSON.stringify(clients),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: () => {
            succ();
          },
          error: (jqXHR, textStatus, errorThrown) => {
            console.error("Error on PUT (Clients) in saveSecurity2Data()");
            onerror({ jqXHR, textStatus, errorThrown });
          },
        });
      };

      //this.$refs.questions2Tab.saveChanges();
      const saveLocations = (succ, onerror) => {
        $.ajax({
          method: "PUT",
          url: `api/UserSecurity/${this.selectedUser}/Locations`,
          data: JSON.stringify(
            this.security2DialogData.dataLists.permittedLocations
          ),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: () => {
            succ();
          },
          error: (jqXHR, textStatus, errorThrown) => {
            console.error("Error on PUT (Locations) in saveSecurity2Data()");
            onerror({ jqXHR, textStatus, errorThrown });
          },
        });
      };

      let clientSettingsData = this.getClientSettingsPutData();
      const saveProjects = (succ, onerror) => {
        $.ajax({
          method: "PUT",
          url: `api/UserSecurity/${this.selectedUser}/Projects`,
          data: JSON.stringify(clientSettingsData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: () => {
            succ();
          },
          error: (jqXHR, textStatus, errorThrown) => {
            console.error(
              "Error on PUT (Client Settings) in saveSecurity2Data()"
            );
            onerror({ jqXHR, textStatus, errorThrown });
          },
        });
      };

      const requests = [
        saveClients,
        saveLocations,
        saveProjects,
        ...refCallbacks,
      ].map((fn) => this.promisfy(fn));

      Promise.all(requests)
        .then((_data) => {
          this.globals.showSuccessSnackbar("Security data update successful");
        })
        .catch((err) => {
          console.error(err);
          if (err.textStatus) {
            this.globals.showErrorSnackbar(
              "Security data update failed " + err.textStatus
            );
          } else {
            this.globals.showErrorSnackbar("Security data update failed");
          }
        });
    },
    getClientSettingsPutData() {
      let projects = this.security2DialogData.dataLists.clientSetting;
      let visibleProjects = [],
        visibleWaves = [];

      for (let project of projects) {
        if (project.Forbidden) visibleProjects.push(project.ProjectGuid);
        else if (project.Waves)
          for (let wave of project.Waves) {
            if (wave.Forbidden) visibleWaves.push(wave.WaveGuid);
          }
      }
      return { Projects: visibleProjects, Waves: visibleWaves };
    },
    hasForbiddenWaves(project) {
      if (!project || project.Forbidden || !project.Waves) return false;
      for (let wave of project.Waves) if (wave.Forbidden) return true;
      return false;
    },
    editUserDialogDataReceived() {
      $("#editUser").modal("show");
    },
    openEditUserDialog(mode) {
      if (mode == "create") {
        this.editUserDialogData.dialogTitle = this.lang.S0052;
        this.editUserDialogData.dialogType = "create";
        this.editUserDialogData.userData.RoleTypeGuid =
          this.roleData[0].RoleTypeGuid;
        delete this.editUserDialogData.userData.RoleGuid;
        this.setCurrentRoles();
        delete this.editUserDialogData.userData.UserId;
        delete this.editUserDialogData.userData.LoginName;
        delete this.editUserDialogData.userData.Password;
        delete this.editUserDialogData.userData.FirstName;
        delete this.editUserDialogData.userData.LastName;
        delete this.editUserDialogData.userData.CompanyName;
        delete this.editUserDialogData.userData.Gender;
        delete this.editUserDialogData.userData.AgencyGuid;
        delete this.editUserDialogData.userData.ClientId;
        delete this.editUserDialogData.userData.Address1;
        delete this.editUserDialogData.userData.Address2;
        delete this.editUserDialogData.userData.City;
        delete this.editUserDialogData.userData.Region;
        delete this.editUserDialogData.userData.Country;
        delete this.editUserDialogData.userData.PostalCode;
        delete this.editUserDialogData.userData.PhoneHome;
        delete this.editUserDialogData.userData.PhoneWork;
        delete this.editUserDialogData.userData.PhoneMobile;
        delete this.editUserDialogData.userData.Fax;
        delete this.editUserDialogData.userData.Email;
        delete this.editUserDialogData.userData.TimeZone;
        this.editUserDialogData.userData.Active = "true";
        delete this.editUserDialogData.userData.LanguageCode;
        // this.editUserDialogData.userData.DateRegistered = "";
        delete this.editUserDialogData.userData.DefaultWelcomePage;
        delete this.editUserDialogData.userData.GeographyFromGeocoding_Lat;
        delete this.editUserDialogData.userData.GeographyFromGeocoding_Long;
        delete this.editUserDialogData.userData.GeographyFromPostalCode_Lat;
        delete this.editUserDialogData.userData.GeographyFromPostalCode_Long;
        delete this.editUserDialogData.userData.DistanceUnit;
        this.changedCountry("");
        $("#editUser").modal("show");
      } else if (mode == "edit") {
        this.editUserDialogData.dialogTitle = this.lang.S0053;
        this.editUserDialogData.dialogType = "edit";
        this.editUserDialogData.userData = {};

        $.ajax({
          method: "GET",
          url: `api/SecurityUsers/${this.selectedUser}`,
          success: (data) => {
            this.editUserDialogDataReceived();
            if (this.copyUser) {
              delete data.LoginName;
            }
            this.editUserDialogData.userData = data; // Store response data from server
            this.changedCountry(this.editUserDialogData.userData.Country); // Load region dropdown depending on the selected country
            if (this.editUserDialogData.userData.LocationProperties) {
              this.editUserDialogData.userData.LocationProperties.forEach(
                (locationPropertie) => {
                  if (
                    locationPropertie.LocationPropertyName === "Market_short"
                  ) {
                    this.editUserDialogData.userData.Market =
                      locationPropertie.LocationPropertyValue;
                  }
                }
              );
            }
            this.setCurrentRoles();
            this.$forceUpdate();
          },
          error: () => {
            console.error("User data access failed in openEditUserDialog()");
            this.globals.showErrorSnackbar("User data access failed");
          },
        });
      } else {
        // Wrong mode
        console.error("Wrong user dialog mode in openEditUserDialog()");
        $("#editUser").modal("hide");
        return false;
      }
      this.editUserDialogData.showAlert = false;
      this.resetValidationErrors("editUser");
      return true; // Mode was ok
    },
    // Catch client list
    getClientList() {
      $.ajax({
        method: "GET",
        url: "api/Data/Clients",
        success: (data) => {
          this.clientList = [];
          for (var x in data) {
            this.clientList.push({ ClientId: x, ClientName: data[x] });
          }

          this.clientList.sort((a, b) => {
            // Sort clients by name
            if (a.ClientName.toLowerCase() < b.ClientName.toLowerCase())
              return -1;
            if (a.ClientName.toLowerCase() > b.ClientName.toLowerCase())
              return 1;
            return 0;
          });
        },
        error: () => {
          console.error("Client data access failed in getClientList()");
          this.globals.showErrorSnackbar("Client data access failed");
        },
      });
    },
    // Catches data for dropdown lists from server
    async getEditUserDialogSelectData() {
      this.globals.getCountryList();
      this.globals.getRegionsList((callbackData) => {
        this.regionList = callbackData;
      });
      this.globals.getLanguageList((callbackData) => {
        this.languageList = callbackData;
      });
      this.globals.getMarketList((callbackData) => {
        this.marketList = callbackData;
      });
      if (this.globals.selectedLanguage)
        this.globals.getRoleData((callbackData) => {
          this.roleData = callbackData;
        });
      this.globals.getTimezonesList((callbackData) => {
        this.timeZones = callbackData;
      });
      this.globals.getDistanceUnitList((callbackData) => {
        this.distanceUnits = callbackData;
      });
      this.globals.getAgencyList((callbackData) => {
        this.agencyList = callbackData;
      });
      this.getClientList();
      this.clientListWithGuid = await this.globals.getClientList();
    },
    saveSelectedMarket() {
      if (this.editUserDialogData.userData.Market_short) {
        let itms = [
          {
            LocationPropertyGuid:
              this.editUserDialogData.userData.Market_short
                .LocationPropertyGuid,
            LocationPropertyValue:
              this.editUserDialogData.userData.Market_short
                .LocationPropertyValue,
          },
        ];
        let url = `api/UserSecurity/${this.editUserDialogData.userData.UserId}/LocationProperties`;
        return UseUserSecurity.LocationProperties.updateforUser(
          this.editUserDialogData.userData.UserId,
          itms
        );
      } else {
        return new Promise((resolve, reject) => {
          // nothing to save
          reject("No market to save.");
        });
      }
    },
    // Sends the data from editUser dialog to the server to store it in the database
    saveEditUserDialogData() {
      if (
        this.feature.isAudiTarget &&
        this.globals.roleTypeHasSuffix(
          this.editUserDialogData.userData.RoleTypeGuid,
          "Audi"
        ) &&
        this.clientList[0] &&
        this.clientList[0].ClientId
      )
        this.editUserDialogData.userData.ClientId = this.clientList[0].ClientId;

      // Security Role -> Admin
      // Bei allen Usern
      if (
        this.feature.isPorscheTarget &&
        this.editUserDialogData.userData.Market_short
      ) {
        this.saveSelectedMarket()
          .then((res) => {
            this.globals.showSuccessSnackbar("Saved Market");
          })
          .catch((err) => {
            console.error(err);
            this.globals.showErrorSnackbar("Error in saveSelectedMarket()");
          });
      }

      if (this.editUserDialogData.dialogType == "create" || this.copyUser) {
        // copy user
        if (this.copyUser) {
          this.editUserDialogData.userData.IsCopyOf =
            this.editUserDialogData.userData.UserId;
          delete this.editUserDialogData.userData.UserId;
        }
        // Create new user
        $.ajax({
          method: "POST",
          url: "api/SecurityUsers",
          data: JSON.stringify(this.editUserDialogData.userData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            if (data.Error) {
              this.globals.showErrorSnackbar(data.Error);
              console.error(data.Error);
              return;
            }
            // If POST was successful, refresh displayed data and hide dialog
            this.globals.showSuccessSnackbar("User creation successful");
            this.getUserData();
            this.selectedUser = data[0].UserId;
            $("#editUser").modal("hide");
            this.copyUser = false;
          },
          error: () => {
            console.error("Error on POST in saveEditUserDialogData()");
            this.globals.showErrorSnackbar("User creation failed");
          },
        });
      } else if (this.editUserDialogData.dialogType == "edit") {
        // Update existing user
        $.ajax({
          method: "PUT",
          url: "api/SecurityUsers/" + this.editUserDialogData.userData.UserId,
          data: JSON.stringify(this.editUserDialogData.userData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            // If PUT was successful, refresh displayed data and hide dialog
            this.globals.showSuccessSnackbar("User update successful");
            this.getUserData();
            $("#editUser").modal("hide");
          },
          error: () => {
            console.error("Error on PUT in saveEditUserDialogData()");
            this.globals.showErrorSnackbar("User update failed");
          },
        });
      } else console.error("Wrong user dialog mode");
    },
    // Calculates the sort order for the given column and refreshes the displayed data
    sortUserData(field) {
      if (field == this.sortField) {
        this.sortOrder == "asc"
          ? (this.sortOrder = "desc")
          : (this.sortOrder = "asc");
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedPage = 1;
      this.getUserData();
    },
    // Catches user data for the table from the server, including current filter, pagination and sort settings
    getUserData() {
      this.refreshEnabled = false; // Disable refresh, so it can not be triggered again until the server responded

      let getString = `api/SecurityUsers/Get?page_size=${this.pageSize}&page=${this.selectedPage}&sort_column=${this.sortField}&sort_order=${this.sortOrder}`;
      getString = encodeURI(getString);

      let filter = _.pickBy(this.filterStrings, (value, key) => {
        if (key === "Active" && value < 2) return true;
        return value.length > 0;
      });
      if (typeof filter.Active === "number") filter.Active = !!filter.Active;

      $.ajax({
        method: "POST",
        url: getString,
        data: _.isEmpty(filter) ? "" : JSON.stringify({ Filter: filter }),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.userData = data[0].Users; // If GET was successful, store user data and page count from server
          this.pageCount = data[0].Page_Count;
          this.totalElementsCount = data[0].Count;

          if (this.selectedUser) {
            let selUser = _.find(this.userData, ["UserId", this.selectedUser]);
            if (selUser) this.selectedUserData = selUser;
          }
        },
        error: () => {
          console.error("Error on POST in getUserData()");
          this.globals.showErrorSnackbar("User data request failed");
        },
        complete: () => {
          this.refreshEnabled = true;
        },
      });
    },
    // Updates the current pagesize and the selected pagenumber and triggers the refresh of the table
    updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getUserData();
    },
    exportUsers() {
      let getString = "api/SecurityUsers/Export";

      if (this.feature.isAudiTarget && this.clientList[0]) {
        this.exportUsersDialogData.UserTypeId = 4;
        this.exportUsersDialogData.ClientId = this.clientList[0].ClientId;
      }

      if (this.exportUsersDialogData.UserTypeId) {
        getString += "?userTypeId=" + this.exportUsersDialogData.UserTypeId;
        if (
          this.exportUsersDialogData.UserTypeId == 4 &&
          this.exportUsersDialogData.ClientId
        )
          getString += "&clientId=" + this.exportUsersDialogData.ClientId;
        if (
          this.exportUsersDialogData.UserTypeId == 2 &&
          this.exportUsersDialogData.AgencyId
        )
          getString += "&agencyId=" + this.exportUsersDialogData.AgencyId;
      }

      let filter = _.pickBy(this.filterStrings, (value, key) => {
        if (key === "Active" && value < 2) return true;
        return value.length > 0;
      });
      if (typeof filter.Active === "number") filter.Active = !!filter.Active;

      getString = encodeURI(getString);

      $.ajax({
        method: "POST",
        url: getString,
        data: _.isEmpty(filter) ? "" : JSON.stringify({ Filter: filter }),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.length > 0 && data[0].DownloadId)
            this.globals.downloadFile(data[0].DownloadId);
        },
        error: (data) => {
          console.error("Error on POST in exportUsers()");
          this.globals.showErrorSnackbar("Users export failed");
        },
      });
    },
    // Returns a range of numbers with min-value, max-value and stepsize
    getRange(min, max, step) {
      var range = [],
        j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },
    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (
        this.pageCount > 7 &&
        this.selectedPage >= this.pageCount - 3
      ) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },
    // open change password dialog
    openChangePasswordDialog() {
      this.showChangePasswordDialog = true;
    },
    onChangePasswordDialogClosed() {
      this.showChangePasswordDialog = false;
    },
    // getSelectedUser(userGuid) {
    //   let result = this.userData.find(user => user.UserId === userGuid);
    //   return `${result.LoginName} (${result.FirstName} ${result.LastName})`;
    // }
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
      this.globals.getRoleData((callbackData) => {
        this.roleData = callbackData;
      });
      this.getUserData();
    },
    selectedSecurity2Page(newValue) {
      if (newValue === "locations2Tab")
        $("#security2Dialog > .modal-dialog").css("width", "80vw");
      else $("#security2Dialog > .modal-dialog").css("width", "50vw");
    },
    "securityDialogData.groupManagement.selectedGroupData": {
      handler(newValue, oldValue) {
        if (_.isEmpty(newValue)) {
          this.securityDialogData.groupManagement.isSelectedGroupDirty = false;
          return;
        }
        if (newValue.GroupGuid === oldValue.GroupGuid)
          this.securityDialogData.groupManagement.isSelectedGroupDirty = true;
        else
          this.securityDialogData.groupManagement.isSelectedGroupDirty = false;
      },
      deep: true,
    },
  },
  data() {
    // Global data inside the component is stored here
    return {
      selectedSecurity2Page: "clientSettings2Tab",
      selectedUser: "", // GUID of the selected user
      selectedUserData: {},
      pageSize: 20, // Number of users on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      pageCount: 0, // Count of available pages depending on the pagesize and the data
      totalElementsCount: 0,
      showImportUsersDialog: false,
      filterStrings: {
        // Strings that are manipulated by the user for filtering the table
        Search: "",
        RoleType: "",
        Role: "",
        Active: 2, // 0 = inactive, 1 = active, 2 = all
        Company: "",
        LoginName: "",
        FirstName: "",
        LastName: "",
        Gender: "",
        City: "",
        Region: "",
        Country: "",
        Email: "",
      },
      sortField: "LoginName", // Selected column for sorting
      sortOrder: "asc", // Should be "asc" or "desc"
      refreshEnabled: false, // false, if user data is requested and server did not respond yet to avoid multiple requests at the same time
      userData: [], // Stores the user data on the current page
      timeZones: [], // List of available timezones
      roleData: [],
      languageList: [], // List of available languages for the user
      regionList: [], // List of all available regions
      agencyList: [], // List of all agencies
      clientList: [],
      clientListWithGuid: [],
      marketList: [], // List of markets
      targetGroups: {},
      distanceUnits: {},
      editUserDialogData: {
        // Data for the editUser dialog
        dialogType: "", // Should be "create" or "edit"
        dialogTitle: "", // Title of the dialog
        userData: {}, // The user data of the selected user is stored here
        currentRoles: [],
        currentRegions: [], // List of regions in the selected country
        currentTimeZones: [],
        showAlert: false, // true --> Alert for validation errors is visible
      },
      securityDialogData: {
        // Data for the securityDialog
        dataLists: {
          // Stores information about roles, security groups and custom groups
          roleData: [],
          securityGroupData: [],
          customGroupData: [],
        },
        assignedGroupGuids: [], // Stores IDs of all groups that are assigned to the selected user
        selectedAssignedGroupGuids: [], // Stores selected assigned groups in the dialog
        selectedUnassignedGroupGuids: [], // Stores selected unassigned groups in the dialog
        groupManagement: {
          // Stores temporary data for the group management tab
          selectedGroup: "",
          selectedGroupData: {},
          isSelectedGroupDirty: false,
        },
      },
      security2DialogData: {
        selectedClient: "",
        showTop100LocationsOnly: true,
        hasAccessToAllLocations: false,
        locationFilterStrings: {
          LocationStoreId: "",
          LocationName: "",
          LocationAddress: "",
          LocationCountry: "",
          LocationStatusId: "",
          LocationVisible: 2,
        },
        dataLists: {
          clientSetting: [],
          selectedClients: [],
          locationProperties: [],
          locations: [],
          filteredLocations: [],
          permittedLocations: [],
        },
      },
      invalidInputIds: [], // IDs of inputs with validation error
      deleteUserDialogData: {},
      showExportDialog: false,
      exportUsersDialogDataUserID: -1,
      exportUsersDialogData: {},
      lang: {
        // Contains localization strings for the selected language
        S0000: "Aktualisieren",
        S0001: "Neuer Benutzer",
        S0002: "Bearbeiten",
        S0003: "Groups",
        S0004: "Suche...",
        S0005: "Elemente pro Seite",
        S0006: "Erste Seite",
        S0007: "Letzte Seite",
        S0008: "Benutzer-ID",
        S0009: "Typ",
        S0010: "Benutzername",
        S0011: "Vorname",
        S0012: "Nachname",
        S0013: "Geschlecht",
        S0014: "Stadt",
        S0015: "Region",
        S0016: "Land",
        S0017: "E-Mail",
        S0018: "Filter",
        S0019: "Allgemein",
        S0020: "Benutzername",
        S0021: "Kennwort",
        S0022: "Vorname",
        S0023: "Nachname",
        S0024: "Firmenname",
        S0025: "Geschlecht",
        S0026: "männlich",
        S0027: "weiblich",
        S0028: "Benutzersprache",
        S0029: "Zeitzone",
        S0030: "Startseite",
        S0031: "Beispiel",
        S0032: "Nicht verwenden",
        S0033: "Account Status",
        S0034: "Aktiviert",
        S0035: "Deaktiviert",
        S0036: "Kontakt",
        S0037: "Straße",
        S0038: "Adresszusatz",
        S0039: "Stadt",
        S0040: "Region",
        S0041: "Bitte auswählen...",
        S0042: "Land",
        S0043: "PLZ",
        S0044: "Telefon privat",
        S0045: "Telefon geschäftlich",
        S0046: "Telefon mobil",
        S0047: "Fax",
        S0048: "E-Mail",
        S0049:
          "Ihre Eingaben sind fehlerhaft. Bitte prüfen Sie alle rot markierten Felder!",
        S0050: "Abbrechen",
        S0051: "Speichern",
        S0052: "Neuer Benutzer",
        S0053: "Benutzer bearbeiten",
        S0054: "Group Security",
        S0055: "Systemgruppen",
        S0056: "Sicherheitsgruppen",
        S0057: "Benutzerdefinierte Gruppen",
        S0058: "Verfügbare Gruppen",
        S0059: "Zugeordnete Gruppen",
        S0060: "Abbrechen",
        S0061: "Speichern",
        S0062: "Passwort",
        S0063: "Kundenrichtlinien",
        S0064: "Gruppenverwaltung",
        S0065: "Kunden",
        S0066: "Richtlinien",
        S0067: "Kunden/ Standort Administration",
        S0068: "Fragebogen erstellen",
        S0069: "Projektplanung",
        S0070: "Zuweisung Management",
        S0071: "Eingereichte Fragebogen Manager",
        S0072: "Kunden Reporting",
        S0073: "Nicht zugewiesen",
        S0074: "Ansicht",
        S0075: "Bearbeiten",
        S0076: "Alle Kunden auswählen",
        S0077: "Auswahl aufheben",
        S0078: "Verfügbare Gruppen",
        S0079: "Gruppen bearbeiten",
        S0080: "Gruppenname",
        S0081: "Beschreibung",
        S0082: "Speichern",
        S0083: "Löschen",
        S0084: "Passwort zurücksetzen",
        S0085: "Neues Passwort",
        S0086: "Neues Passwort wiederholen",
        S0087: "Konto entsperren",
        S0088: "Die eingegebenen Passwörter stimmen nicht überein!",
        S0089: "Abbrechen",
        S0090: "Speichern",
        S0091: "Nicht zugewiesen",
        S0092: "Ansicht",
        S0093: "Bearbeiten",
        S0095: "Diese Angabe ist erforderlich!",
        S0096: "Dies ist keine gültige Telefonnummer!",
        S0097: "Dies ist keine gültige Faxnummer!",
        S0098: "Dies ist keine gültige E-Mail Adresse!",
        S0099: "Benutzer löschen",
        S0100: "Soll folgender Benutzer wirklich gelöscht werden?",
        S0101: "Ja",
        S0102: "Nein",
        S0103: "Anzeigen",
        S0104: "Bearbeiten",
        S0105: "Standortrichtlinien",
        S0106: "Benutzereigenschaftenrichtlinien",
        S0107: "Fragebogenrichtlinien",
        S0108: "Standort",
        S0109: "Genehmigt",
        S0110: "Nicht genehmigt",
        S0111: "Kunde",
        S0112: "Bitte auswählen",
        S0113: "Benutzereigenschaft",
        S0114: "Wert der Benutzereigenschaft",
        S0115: "Fragebogen",
        S0116: "Agentur",
        S0117: "Breitengrad aus Geokodierung",
        S0118: "Längengrad aus Geokodierung",
        S0119: "Breitengrad aus PLZ",
        S0120: "Längengrad aus PLZ",
        S0121: "Entfernungseinheit",
        S0122: "Ungültiger Wert",
        S0123: "Projekte",
        S0124: "Projekt",
        S0125: "Projektwellen",
        S0126: "Reporting Features",
        S0127: "Check Explorer",
        S0128: "Media Explorer",
        S0129: "Raw Data",
        S0130: "Frequencies",
        S0131: "Aggregated Reports",
        S0132: "Fragen",
        S0133: "Security Role",
        S0134: "Export",
        S0135: "Import",
        S0138: "User Security",
        S0139: "Client Settings",
        S0140: "Location Properties",
        S0141: "Locations",
        S0142: "Reporting Features",
        S0143: "Questions",
        S0144: "Visibility",
        S0145: "Client Level",
        S0146: "Copy User",
        S0147: "Auto next Wave",
        S0148: "Passwortrichtlinien",
        S0149: "Buchstaben",
        S0150: "Großbuchstabe(n)",
        S0151: "Kleinbuchstabe(n)",
        S0152: "Ziffer(n)",
        S0153: "Sonderzeiche(n)",
        S0154: "mindestens",
        S0155: "Client Selection",
        S0156: "Client Level (select all levels)",
        S0157: "Scenarios",
        S0158: "Please select clients in Client Selection tab first.",
        S0159: "New",
        S0160: "Company",
        S0161: "Security",
        S0162: "Permitted",
        S0163: "Active",
        S0164: "Close",
        S0165: "Project Level",
        S0166: "StoreID",
        S0167: "Status",
        S0168: "Address",
        S0169: "Name",
        S0170: "Location Property",
        S0171: "Location Property Values",
        S0172: "Visible",
        S0173: "Show only top 100 locations",
        S0174: "Projectname",
        S0175: "Hide",
        S0176: "No waves available for this project",
        S0177: "Wavename",
        S0178: "User",
        S0179: "Country",
        S0180: "Export Users",
        S0181: "Download",
        S0182: "Cancel",
        S0183: "User Type",
        S0184: "Please select an user type...",
        S0185: "Client",
        S0186: "Please select a client...",
        S0187: "Partner",
        S0188: "Please select a partner...",
        S0189: "Grant access to all locations",
        S0190: "Access to all locations granted",
        S0191: "Reporting Group",
        S0192: "Delete Security Group",
        S0193: "Do you really want to delete the following group?",
        S0194: "Groupname",
        S0195: "Client selection is required for reporting groups.",
        S0196:
          "Reporting settings are needed for the client. Please contact the support!",
        S0197: "Target group",
        S0198: "Target group already in use",
        S0199:
          "This target group is already assigned to another security group. If you save the current group, the target groups will be swapped.",
        S0200: "Total users count",
        S0201: "Show user history",
        S0202: "Market",
        S0203: "divers",
      },
      copyUser: false,
      showChangePasswordDialog: false,
    };
  },
};
</script>

<style>
#security2DialogClientSelect ~ .select2.select2-container {
  margin: 0;
  float: none;
}

#securityDialog .tooltip > .tooltip-inner {
  max-width: 300px;
}
</style>

<style scoped>
/* Tabs on security dialog */
.nav-security {
  background-color: var(--color-primary);
}
.nav-security > li {
  text-align: center;
  float: none;
  display: inline-block;
}
.nav-security > li.active {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Buttons on client policies tab in the security dialog */
.btn-policies {
  width: 100%;
  text-align: left;
}
.btn-cb-policies {
  margin: 0px;
  padding: 0 10px 0 10px;
  color: blue;
}
td.td-cb-policies {
  padding: 7px;
}

.form-group-small {
  display: inline;
}
.table {
  text-align: center;
}

.group-title {
  text-align: left;
}
.sub-group-title {
  text-align: left;
  padding-left: 30px;
}

.cb-active-filter-container {
  margin-top: 7px;
  color: var(--color-primary-input);
}

td > .user-active {
  padding: 0px;
  color: green;
}
td > .user-inactive {
  padding: 0px;
  color: red;
}

#locations2Tab .main-table-scrollbar {
  max-height: calc(100vh - 540px);
}

#security2Dialog > .modal-dialog {
  width: 50vw;
  transition: all 200ms ease;
}

#clientSettings2Tab > div {
  max-height: calc(100vh - 360px);
  overflow: auto;
}

#clientSettings2Tab table {
  text-align: left;
}
#clientSettings2Tab table table {
  width: calc(100% - 40px);
  margin: 0 20px 0 20px !important;
}

#clientSettings2Tab table.outer-table > tbody > tr.background-grey:hover > td,
#clientSettings2Tab table.outer-table > tbody > tr:hover > th {
  background-color: lightgray;
}

#clientSettings2Tab .hiddenRow {
  padding: 0 !important;
}

#clientSettings2Tab .background-grey {
  background-color: #ededed;
}

#clientSettings2Tab .project-name-data {
  padding: 10px 0 0 8px;
}
#clientSettings2Tab .project-name-data > i {
  vertical-align: middle;
}
#clientSettings2Tab .project-name-data + td i {
  vertical-align: middle;
  margin-top: -4px;
}

#groupManagementTab .btn-top-bar {
  margin: 10px;
}

.reporting-group-table-symbol {
  font-weight: 1000;
  font-size: 16px;
  position: absolute;
  right: 25px;
}

#groupManagementTab .btn-top-bar.btn.btn-raised.btn-warning {
  background-color: #ff5722;
}
#groupManagementTab .btn.btn-raised.btn-warning:hover {
  background-color: #ec5122ab;
}

#groupManagementTab .form-group > label > i.material-icons {
  position: absolute;
  top: -3px;
  right: 5px;
}

#customGroupDataTab > .col-md-6 {
  max-height: calc(100vh - 320px);
  overflow: auto;
}
#groupManagementTab > .col-md-6 {
  max-height: calc(100vh - 280px);
  overflow: auto;
}
#showUserHistoryInfoIcon {
  position: relative;
  left: 10px;
  margin: -5px;
  vertical-align: middle;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// UserManagement.vue?066006fe